import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPaperclip, faFileArrowDown, faPaperPlane, faTimes, faFilter, faFileLines, faEllipsisVertical, faPencilAlt, faCircle, faUser, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { Form, Button, Accordion, Row, Col, Modal, Table, Tabs, Tab, Dropdown } from 'react-bootstrap';
import { withRFSToken } from '../../../../../Services/axios';
import { ADDRESSBOOKDROPDOWN, GETDESTINATION, GETOWNERCODE, SHIPMENTSAVEINVOICECATEGORY } from '../../../../../Utils/conts';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import CreatableSelect from 'react-select/creatable';
import AssetsIcon from '../../../../../assets/images/oparation.svg';
import Radown from "../../../../../assets/images/radown.png";
import AssetsIconw from '../../../../../assets/images/oparation_a.svg';
import Docmnt from '../../../../../assets/images/file.svg';
import Pack from '../../../../../assets/images/n_package.png';
import Uploadn from '../../../../../assets/images/upload-n.png';
import Uploadw from '../../../../../assets/images/upload-w.png';
import Trash from "../../../../../assets/images/trash.png";
import Shipupload from "../../../../../assets/images/ship_upload.png";
import dlt from '../../../../../assets/images/dlt.png';
import edit from "../../../../../assets/images/edit.png";
import Rapdf from "../../../../../assets/images/pdf.png";
import TrashRed from "../../../../../assets/images/trash_red.png";
import { saveAs } from "file-saver";
import Customer from '../../../../Settings/FSM/CustomerSettings';
import { CallApi, getTodayDateTime } from '../../../../../Components/common/CommonFunctions';
import TableGrid from '../../../../../Components/common/TableGrid'
import { useUserCheckQuery } from '../../../../../redux/services/Auth';

const AddExport = ({ goParent, type }) => {

    const isMounted = useRef(false);
    const incotermOption = [
        { label: '--', value: '-' },
        { label: 'EXW - Ex Works', value: 'EXW' },
        { label: 'FCA - Free Carrier', value: 'FCA' },
        { label: 'FAS - Free Alongside Ship', value: 'FAS' },
        { label: 'FOB - Free On Board', value: 'FOB' },
        { label: 'CPT - Carriage Paid To', value: 'CPT' },
        { label: 'CIP - Carriage and Insurance Paid', value: 'CIP' },
        { label: 'CFR - Cost and Freight', value: 'CFR' },
        { label: 'CIF - Cost Insurance and Freight', value: 'CIF' },
        { label: 'DAP - Delivered At Place', value: 'DAP' },
        { label: 'DPU - Delivered At Place Unloaded', value: 'DPU' },
        { label: 'DDP - Delivered Duty Paid', value: 'DDP' }
    ];
    const columns = [
        { label: "Label ID", field: "label", enableSearch: false, cls: 'tw-25' },
        {
            label: "Take In", field: "take_in", enableSearch: false, cls: 'tw-25',
            renderCell: (row) => getTodayDateTime(row.take_in, "DMY"),
        },
        {
            label: "Report Pdf", field: "receipt", enableSearch: false, cls: 'tw-25',
            renderCell: (row) =>
                row?.receipt ? (
                    <div style={{ textAlign: "center" }}>
                        <a href={row.receipt} target="_blank" rel="noopener noreferrer">
                            <img src={Rapdf} alt="PDF" style={{ width: "25px", cursor: "pointer" }} />
                        </a>
                    </div>
                ) : null,
        },
        {
            label: "Delete", field: "delete", enableSearch: false, renderCell: (row) => (
                <div>
                    <img
                        src={TrashRed}
                        alt="Delete"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            setDeleteIds([row.id]);
                            setShowDeleteConfirm(true);
                        }}
                    />
                </div>
            ),
        }
    ];

    const groundHandlerOption = [
        { label: '--', value: '-' },
        { label: 'Direct Pickup', value: 'Direct Pickup' },
        { label: 'KLM', value: 'KLM' },
        { label: 'Dnata', value: 'Dnata' },
        { label: 'Swissport T9', value: 'Swissport T9' },
        { label: 'Swissport T11', value: 'Swissport T11' },
        { label: 'WFS VR9', value: 'WFS VR9' },
        { label: 'WFS VR8', value: 'WFS VR8' },
        { label: 'WFS VR6', value: 'WFS VR6' },
        { label: 'DHL', value: 'DHL' },
    ];
    const [deleteIds, setDeleteIds] = useState([]);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [formData, setFormData] = useState({
        master_airwaybill: "",
        sec_status: 'U',
        screening: '0',
        screening_planned: '0',
        latManualOverride: false,
        destination_airport: "",
        incoterm: "",
        hawb: "",
        job_nr: "",
        wms_nr: [],
        shipper: "",
        consignee: "",
        reference: "",
        location: "",
        pieces: "",
        gross_weight: "",
        volume_weight: "",
        dimensions: [
            { id: '1', pieces: '', length: '', width: '', height: '', }
        ],
        flight_details: [
            { id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', eta: '', ata: '' }
        ],
        all_currency: "EUR",
        air_freight_buying: "",
        air_freight_selling: "",
        air_freight_currency: "EUR",
        fuel_surcharge_buying: "",
        fuel_surcharge_selling: "",
        fuel_surcharge_currency: "EUR",
        security_surcharge_buying: "",
        security_surcharge_selling: "",
        security_surcharge_currency: "EUR",
        terminal_handling_fee_buying: "",
        terminal_handling_fee_selling: "",
        terminal_handling_fee_currency: "EUR",
        trucking_buying: "",
        trucking_selling: "",
        trucking_currency: "EUR",
        customs_clearance_buying: "",
        customs_clearance_selling: "",
        customs_clearance_currency: "EUR",
        security_scanning_buying: "",
        security_scanning_selling: "",
        security_scanning_currency: "EUR",
        handling_fee_buying: "",
        handling_fee_selling: "",
        handling_fee_currency: "EUR",
        packing_fee_buying: "",
        packing_fee_selling: "",
        packing_fee_currency: "EUR",
        profit_buying: "",
        profit_selling: "",
        profit_currency: "EUR",
        dangerous_goods_fee_buying: "",
        dangerous_goods_fee_selling: "",
        dangerous_goods_fee_currency: "EUR",

        flight1_via: "",
        flight1_etd: "",
        flight1_eta: "",
        flight1_remarks: "",
        flight2_via: "",
        flight2_etd: "",
        flight2_eta: "",
        flight2_remarks: "",
        flight3_via: "",
        flight3_etd: "",
        flight3_eta: "",
        flight3_remarks: "",
        haulier: "",
        loading_place: "",

        pick_up: "",
        pick_up_check: "",
        warehouse_inbound_check: "",
        warehouse_inbound: "",
        screening_date: "",
        checks_completed_check: "",
        checks_completed: "",
        customs_document: "",
        exa_prepared_by_kerry: "",
        documents: "",
        awb_instruction: "",
        awb_draft_send: "",
        awb_approved: "",
        pre_alert_send: "",
        fwb_fhl: ""
    });
    const [quotationFormData, setQuotationFormData] = useState({});
    const [getLocalCharges, setGetLocalCharges] = useState({})
    const currencies = [
        { value: "EUR", label: "EUR (€) - Euro" },
        { value: "USD", label: "USD ($) - US Dollar" },
        { value: "PHP", label: "PHP (₱) - Philippine Peso" },
        { value: "JPY", label: "JPY (¥) - Japanese Yen" },
        { value: "GBP", label: "GBP (£) - British Pound" },
        { value: "AUD", label: "AUD (A$) - Australian Dollar" },
        { value: "CHF", label: "CHF (Fr.) - Swiss Franc" },
        { value: "CAD", label: "CAD (C$) - Canadian Dollar" },
        { value: "MXN", label: "MXN ($) - Mexican Peso" },
        { value: "CNY", label: "CNY (¥) - Chinese Yuan" },
        { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar" },
        { value: "SEK", label: "SEK (kr) - Swedish Krona" },
        { value: "RUB", label: "RUB (₽) - Russian Ruble" },
        { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar" },
        { value: "NOK", label: "NOK (kr) - Norwegian Krone" },
        { value: "SGD", label: "SGD (S$) - Singapore Dollar" },
        { value: "TRY", label: "TRY (₺) - Turkish Lira" },
        { value: "KRW", label: "KRW (₩) - South Korean Won" },
        { value: "ZAR", label: "ZAR (R) - South African Rand" },
        { value: "BRL", label: "BRL (R$) - Brazilian Real" },
        { value: "INR", label: "INR (₹) - Indian Rupee" },
        { value: "SAR", label: "SAR (﷼) - Saudi Riyal" },
        { value: "DKK", label: "DKK (kr) - Danish Krone" },
        { value: "RON", label: "RON (lei) - Romanian Leu" },
        { value: "XAF", label: "XAF (Fr) - Central African CFA Franc" },
        { value: "XOF", label: "XOF (Fr) - West African CFA Franc" },
        { value: "DOP", label: "DOP (RD$) - Dominican Peso" },
        { value: "HTG", label: "HTG (G) - Haitian Gourde" },
        { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar" },
        { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar" },
        { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar" },
        { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder" },
        { value: "COP", label: "COP (COL$) - Colombian Peso" },
        { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights" },
        { value: "XBT", label: "XBT (₿) - Bitcoin" },
        { value: "WGH", label: "WGH - West German Hard Currency" }
    ];

    const customStatus = [
        { label: 'C', value: 'C' },
        { label: 'N', value: 'N' },
        { label: 'X', value: 'X' },
        { label: 'T1', value: 'T1' },
        { label: 'T2', value: 'T2' },
        { label: 'T2L', value: 'T2L' },
    ]

    const securityStatus = [
        { label: 'SCO', value: 'SCO' },
        { label: 'SHR', value: 'SHR' },
        { label: 'NSC', value: 'NSC' },
    ]
    const [stationRate, setStationRate] = useState([]);
    const [stationRateData, setStationRateData] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [getDg, setGetDg] = useState([]);
    const [quotationId, setQuotationId] = useState(JSON.parse(localStorage.getItem('id')));
    const [disLoading, setDisLoading] = useState(false);
    const defaultRows = [{ no: 1, services: '', origin: '', rate: '', units: '', total: '' }]
    const defaultAfRows = [{ no: 1, airline: '', product: '', to: '', via: '', freight: '', base: '', rate: '', fuel: '', risk: '', fees: '', freightAmount: '', surcharges: '', validity: '', total: '' }]
    const [rows, setRows] = useState([]);
    const [afRows, setAFRows] = useState([]);
    const [isVwaReadOnly, setIsVwaReadOnly] = useState(!!localStorage.getItem('SHEdit'));
    const [getWms, setGetWms] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [userList, setUserList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [quotation, setQuotation] = useState([]);
    const userId = localStorage.getItem('Email')

    const [packageShow, setPackageShow] = useState(true);
    const [savedPackages, setSavedPackages] = useState([]);
    const [packageGroups, setPackageGroups] = useState([
        { number_of_packages: '', length: '', width: '', height: '', gross_weight: "", volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }
    ]);
    const [editIndex, setEditIndex] = useState(null);
    const [rp_kg, setRp_kg] = useState();
    const [divisor, setDivisor] = useState();

    const [contactModal, setContactModal] = useState(false);
    const [getCustomer, setGetCustomer] = useState([]);
    const cgridRef = useRef(null);
    const [cgridData, setCgridData] = useState([]);
    const [isLoadingc, setIsLoadingc] = useState(true);
    const [customerGridSelect, setCustomerGridSelect] = useState([]);
    const [locationModal, setLocationModal] = useState(false);
    const [addLocationModal, setAddLocationModal] = useState(false);
    const [locationData, setLocationData] = useState({});
    const [isLoadingl, setIsLoadingl] = useState(true);
    const lgridRef = useRef(null);
    const [locationGridSelect, setLocationGridSelect] = useState([]);
    const [userDetails, setUserDetails] = useState();

    const hasSHEdit = localStorage.getItem("SHEdit");

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDg = async () => {
        try {

            const res = await withRFSToken.get("setting/get-dg-list")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.un_no,
                        label: `${item.proper_shipping_name} - ${item.un_no} - Class: ${item.dg_class}`,
                    })) : [];
                    setGetDg(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchQuotation = async (id, type) => {
        try {
            const params = { id };
            if (type) params.type = type; // only include type if provided
            const response = await withRFSToken.get("quotation-details", { params });
            const q = response?.data?.response_data;
            setQuotation(q);
            setSavedPackages(Array.isArray(q?.packages) ? q.packages : []);
            if (q?.services_charges && Array.isArray(q.services_charges)) {
                setRows(q.services_charges);
            }
            if (q?.airfreight && Array.isArray(q.airfreight)) {
                const airfreightWithOptionalColumns = q.airfreight.map(row => ({
                    ...row,
                    showOptionalColumns: row.showOptionalColumns || false
                }));
                setAFRows(airfreightWithOptionalColumns);
            }
            const tabtype = q?.origin ? "export" : "import";
            fetchStationRate(tabtype);
            setDisLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchStationRate = async (tabtype, populateRows = false) => {
        try {

            const response = await withRFSToken.get(`station-rate/show?type=${tabtype}`);
            const innerData = response?.data?.response_data;
            //  if (response?.data?.response_code === 200 && Array.isArray(innerData) && innerData.length === 0) {
            //         toast.error(`No station rate data found for ${tabtype}. Please configure it in Settings before proceeding.`);
            //         return;
            // }
            setStationRateData(innerData);
            const transformedData = innerData ? innerData.map(item => ({
                value: item.services,
                label: item.services
            })) : [];
            setStationRate(transformedData);
            if (populateRows && Array.isArray(innerData)) {
                const mappedRows = innerData.map(item => ({
                    services: item.services || '',
                    origin: item.origin || '',
                    destination: item.destination || '',
                    rate: item.rate || '',
                    units: item.units || '',
                    total: item.total || '',
                    service_type: 'select',
                }));
                setRows(mappedRows);
            }

        } catch (error) {
            console.error("Error Fetching Station Rates")
        }
    }
    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.airline_name,
                        airline_name: item.airline_name
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchCustomer = async (agent_or_customer) => {
        try {
            const res = await withRFSToken.get(`address-book/list?agent_or_customer=${agent_or_customer}`)
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setGetCustomer(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchSettings = async () => {
        try {
            const res = await withRFSToken.get('general-setting/get-setting');
            const innerData = res?.data?.response_data?.settings;
            setRp_kg(parseFloat(innerData.rate));
            setDivisor(parseFloat(innerData.divisor))
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };

    const formatToInputDate = (dateString) => {
        const d = new Date(dateString.replace(" ", "T"));
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    const fetchUser = async (edidId) => {
        try {

            const res = await withRFSToken.get(`uld-setting/get-user-list`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.user_id,
                        label: item.first_name + ' ' + item.last_name,
                        email: item.email_id,
                    })) : [];
                    setUserList(transformedData);
                    // if (innerData.length > 0) {
                    if (!edidId) {
                        const isDefault = innerData?.find(dflt => dflt.email_id == userDetails?.email_id)
                        setFormData(prevFormData => ({ ...prevFormData, assigned_to: isDefault?.user_id }))
                    } else {
                        const res = withRFSToken.post(`shipment/export-shipment-record-details/${edidId}`, {})
                            .then(function (res) {
                                const innerDatas = res.data.response_data;
                                let wmsNr = innerDatas.wms_nr;
                                if (typeof wmsNr === 'string') {
                                    try {
                                        wmsNr = JSON.parse(wmsNr);
                                    } catch (e) {
                                        wmsNr = wmsNr ? [wmsNr] : [];
                                    }
                                }
                                if (!Array.isArray(wmsNr)) {
                                    wmsNr = wmsNr ? [wmsNr] : [];
                                }

                                const transformData = {
                                    ...innerDatas,
                                    // assigned_to: innerDatas.assigned_to == null ? isDefault?.user_id : innerData.assigned_to,
                                    dimensions: innerDatas.dimensions?.length > 0 ? innerDatas.dimensions : [{ id: '1', pieces: '', length: '', width: '', height: '', }],
                                    flight_details: innerDatas?.flight_details?.length > 0 ? innerDatas.flight_details : [{ id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: '' }] || [{ id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: '' }],
                                    setting_status: innerDatas.setting_status?.id,
                                    setting_department: innerDatas.setting_department?.id,
                                    flight_lat: innerDatas.flight_lat ? formatToInputDate(innerDatas.flight_lat) : "",
                                    wms_nr: wmsNr,
                                }
                                setFormData(transformData);
                                setDisLoading(false);
                                fetchDepartment(innerDatas?.setting_department?.id);
                                handlelog(edidId);
                            });
                    }

                    // }

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchStatus = () => {
        CallApi({
            endPoint: "shipment/get-settings?tab=export&type=S",
            method: 'GET',
            onSuccess: (res) => {
                const innerData = res.data.Rows;
                if (innerData.length > 0) {
                    const isDefault = innerData?.find(dflt => dflt.is_default === 1)
                    setFormData(prevFormData => ({ ...prevFormData, setting_status: isDefault.id }))
                }
            },
            onError: (msg) => console.error('Error fetching data:', msg)
        })
    };
    const fetchDepartment = async (id) => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=export&type=D`, {})
                .then(function (res) {

                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                        status: item.status_are
                    })) : [];
                    setDepartmentList(transformedData);
                    if (id) {
                        const findDep = innerData.find(did => did.id === id)
                        const transformedData = findDep.status_are
                            ? findDep?.status_are?.map((item) => ({
                                value: item.id,
                                label: item.name,
                            }))
                            : [];
                        setStatusList(transformedData);
                    }

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchwms = async () => {
        try {

            const res = await withRFSToken.get('shipment/get-label-ids')
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.label,
                    })) : [];
                    setGetWms(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (formData?.connected_records && formData.connected_records.length > 0) {
            const firstRecord = formData.connected_records[0];
            if (firstRecord?.take_in) {
                const takeInDate = new Date(firstRecord.take_in);
                if (!isNaN(takeInDate.getTime())) {
                    const formattedDate = takeInDate.toLocaleString('sv-SE').slice(0, 16);
                    setFormData(prev => ({ ...prev, warehouse_inbound_check: '1', warehouse_inbound: formattedDate, }));
                }
            }
        }
    }, [formData?.connected_records]);
    useEffect(() => {
        if (isMounted.current) return;
        const localData = JSON.parse(localStorage.getItem('SHEdit'));
        if (quotationId) { setSelectedTab('vwa'); fetchQuotation(quotationId) }
        if (localData) { fetchUser(localData); setDisLoading(true); } else { fetchUser(); }
        fetchStatus();
        fetchOwnerCode();
        fetchDestination();
        fetchDg();
        fetchwms();
        fetchSettings();
        fetchCustomer('C');
        handleGetOrg();

        const initQuotationRaw = localStorage.getItem('AddExportInitQuotation');
        if (initQuotationRaw) {
            try {
                const initQuotation = JSON.parse(initQuotationRaw);
                setQuotation(initQuotation.quotation || {});
                setSavedPackages(Array.isArray(initQuotation.savedPackages) ? initQuotation.savedPackages : []);
                setSelectedTab('vwa');
                const st = (initQuotation?.quotation?.shipment_type || '').toString().toLowerCase();
                const type = (st == 'e') ? 'export' : 'import';
                fetchStationRate(type, true);
            } catch (e) {
                // ignore
            }
            // localStorage.removeItem('AddExportInitQuotation');
        } else if (quotationId) {
            setSelectedTab('vwa');
            fetchQuotation(quotationId);
        }
        isMounted.current = true;
    }, []);

    let shId = null;
    try {
        const raw = localStorage.getItem('SHEdit');
        shId = raw ? JSON.parse(raw) : null;
    } catch (e) {
        shId = null;
    }
    const addexp = JSON.parse(localStorage.getItem('addexport'))


    const [activeStep, setActiveStep] = useState(0);
    const [activeTab, setActiveTab] = useState('All');
    const [selectedButton, setSelectedButton] = useState('general');
    const [sendData, setSendData] = useState({});
    const [checkList, setCheckList] = useState({});

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [files, setFiles] = useState([]);
    const [rfiles, setRfiles] = useState([]);
    const fileInputRef = useRef(null);
    const fileInputRefs = useRef({});
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [uploadTarget, setUploadTarget] = useState('');

    const calculateLAT = (etd, dangerousGoods) => {
        if (!etd) return '';
        const lat = new Date(etd);
        // DG = Yes -> 48h before ETD, No -> 24h before ETD
        lat.setHours(lat.getHours() - (dangerousGoods == 1 ? 48 : 24));
        // Reformat for datetime-local input
        const offset = lat.getTimezoneOffset();
        const localDate = new Date(lat.getTime() - offset * 60000);
        return localDate.toISOString().slice(0, 16);
    };

    const addDimension = () => {
        const lastId = formData.dimensions.length > 0 ? parseInt(formData.dimensions[formData.dimensions.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => ({
            ...prevFormData,
            dimensions: [
                ...prevFormData.dimensions,
                {
                    id: newId,
                    pieces: '', length: '', width: '', height: '',
                }
            ]
        }));
    };
    const addFlight = () => {
        const lastId = formData.flight_details.length > 0 ? parseInt(formData.flight_details[formData.flight_details.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => ({
            ...prevFormData,
            flight_details: [
                ...prevFormData.flight_details,
                {
                    id: newId,
                    flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: ''
                }
            ]
        }));
    };
    const removeDimension = (dimensionId) => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                dimensions: prevFormData.dimensions.filter(stack => stack.id !== dimensionId)
            };
        });
    };
    const removeFlight = (dimensionId) => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                flight_details: prevFormData.flight_details.filter(stack => stack.id !== dimensionId)
            };
        });
    };

    const handleDnChange = (dimensionId, fieldName, value) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            dimensions: prevFormData.dimensions.map(stack => {
                if (stack.id === dimensionId) {
                    const updatedStack = { ...stack, [fieldName]: value };
                    return updatedStack;
                }
                return stack;
            })
        }));
    }
    const handleFlChange = (flightId, fieldName, value) => {
        setFormData(prevFormData => {
            const updatedFormData = {
                ...prevFormData,
                flight_details: prevFormData.flight_details.map(stack =>
                    stack.id === flightId ? { ...stack, [fieldName]: value } : stack
                ),
            };
            if (fieldName === 'eta' && !prevFormData.latManualOverride) {
                updatedFormData.flight_lat = calculateLAT(value, prevFormData.dangerous_goods);
            }
            return updatedFormData;
        });
    };

    // Calculate volumetric and chargeable weight for a package group
    const calculatePackageMetrics = (group) => {
        const length = parseFloat(group.length) || 0;
        const width = parseFloat(group.width) || 0;
        const height = parseFloat(group.height) || 0;
        const qty = parseFloat(group.number_of_packages) || 0;
        const grossWeight = parseFloat(group.gross_weight) || 0;

        const divisorValue = Number(divisor) || 6000;
        const volumetricWeight = (length * width * height * qty) / divisorValue;
        const chargeableWeight = Math.max((grossWeight * qty), volumetricWeight);
        const totalFreightCost = chargeableWeight * (rp_kg || 0);
        const totalGrossWeight = grossWeight;

        return {
            volumetric_weight: volumetricWeight ? volumetricWeight.toFixed(2) : '',
            chargeable_weight: chargeableWeight ? chargeableWeight.toFixed(2) : '',
            total_freight_cost: totalFreightCost ? totalFreightCost.toFixed(2) : '',
            totalGrossWeight: totalGrossWeight ? totalGrossWeight.toFixed(2) : ''
        };
    };

    // Calculate totals for all saved packages
    const totals = useMemo(() => {
        let totalVolumetric = 0;
        let totalChargeable = 0;
        let totalGrossWeight = 0;
        if (Array.isArray(savedPackages)) {
            savedPackages.forEach((pkg) => {
                const metrics = calculatePackageMetrics(pkg);
                totalVolumetric += Number(metrics.volumetric_weight) || 0;
                totalChargeable += Number(metrics.chargeable_weight) || 0;
                totalGrossWeight += Number(metrics.totalGrossWeight);
            });
        }
        return {
            totalVolumetricWeight: totalVolumetric ? totalVolumetric.toFixed(2) : '0.00',
            totalChargeableWeight: totalChargeable ? totalChargeable.toFixed(2) : '0.00',
            totalGrossWeight: totalGrossWeight ? totalGrossWeight.toFixed(2) : null
        };
    }, [savedPackages, divisor, rp_kg]);

    useEffect(() => {
        const cw = parseFloat(totals?.totalChargeableWeight) || 0;

        setAFRows(prev =>
            prev.map(row => {
                const rate = parseFloat(row.rate) || 0;
                const calc = (rate * cw).toFixed(2);
                return {
                    ...row,
                    freightAmount: calc,
                    total: calc,
                };
            })
        );
    }, [totals?.totalChargeableWeight]);

    useEffect(() => {
        if (!locationModal || !lgridRef?.current || !window?.$) {
            return;
        }

        const token = "Bearer " + localStorage.RFS;
        const source = {
            datatype: 'json',
            datafields: [
                { name: 'id', type: 'string' },
                { name: 'location', type: 'string' },
                { name: 'activity_status', type: 'string' },
                { name: 'created_by', type: 'string' },
                { name: 'station', type: 'string' }
            ],
            url: `${process.env.REACT_APP_RFS_URL}forwarder-location/list`,
            beforeSend: function (jqXHR) {
                jqXHR.setRequestHeader('Authorization', token);
            },
            pagesize: 20,
            root: "Rows",
            cache: false
        };

        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
            {
                text: 'Actions',
                width: '6%',
                filterable: false,
                cellsrenderer: function () {
                    return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                }
            },
            {
                text: 'Sl. No', datafield: 'sl_no', width: '15%',
                cellsrenderer: (rowIndex) => {
                    const serialNo = rowIndex + 1;
                    const formattedNo = serialNo < 10 ? `0${serialNo}` : `${serialNo}`;
                    return `<div class="grid_actions">${formattedNo}</div>`;
                }
            },
            {
                text: 'Status', datafield: 'activity_status', width: '15%',
                cellsrenderer: (rowIndex, dataField, cellValue) => {
                    const isActive = cellValue === '1' || cellValue === 1;
                    const status = isActive ? 'Active' : 'Inactive';
                    const colorClass = isActive ? 'text-success' : 'text-danger';
                    return `<div class="jqx-grid-cell-left-align ${colorClass}" style="margin-top: 12px; margin-left:5px">${status}</div>`;
                }
            },
            { text: 'Location', datafield: 'location', width: '15%' },
            { text: 'Station', datafield: 'station', width: '15%' },
            { text: 'Created By', datafield: 'created_by', width: '15%' },
        ];

        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 500,
            sortable: true,
            columnsresize: false,
            selectionmode: 'checkbox',
            pageable: true,
            pagesize: 20,
            pagesizeoptions: ['20', '50', '100', '200'],
            filterable: true,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
        };

        const gridElement = window.$(lgridRef.current);
        gridElement.jqxGrid(gridOptions);
        gridElement.find('.jqx-grid-column-header').css('background-color', 'white');

        gridElement.find('div[role="row"]').each((index, row) => {
            window.$(row).on('mouseover', () => {
                window.$(row).addClass('row-hover');
            });
            window.$(row).on('mouseout', () => {
                window.$(row).removeClass('row-hover');
            });
        });

        gridElement.on('click', '.row_edit', function () {
            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndex = window.$(rowDiv).attr('row-id');
            const rowData = gridElement.jqxGrid('getrowdata', rowIndex);
            if (rowData) {
                setAddLocationModal(true);
                setLocationData({ id: rowData?.id, station: rowData?.station, location: rowData?.location });
            }
        });

        gridElement.on('rowselect', (event) => {
            if (event.args?.row) {
                setLocationGridSelect([event.args.row]);
            }
        });

        gridElement.on('rowunselect', () => {
            setLocationGridSelect([]);
        });

        return () => {
            if (lgridRef.current && window?.$) {
                try {
                    window.$(lgridRef.current).jqxGrid('destroy');
                } catch (error) {
                    console.error('Failed to destroy location grid', error);
                }
            }
        };
    }, [locationModal]);

    const handleGroupChange = (index, field, value) => {
        const updatedGroups = [...packageGroups];
        updatedGroups[index][field] = value;

        if (['length', 'width', 'height', 'number_of_packages', 'gross_weight'].includes(field)) {
            const metrics = calculatePackageMetrics(updatedGroups[index]);
            updatedGroups[index].volumetric_weight = metrics.volumetric_weight;
            updatedGroups[index].chargeable_weight = metrics.chargeable_weight;
            updatedGroups[index].total_freight_cost = metrics.total_freight_cost;
        }

        setPackageGroups(updatedGroups);
    };

    const handleDeleteGroup = (index) => {
        if (packageGroups.length > 1) {
            const updatedGroups = packageGroups.filter((_, idx) => idx !== index);
            setPackageGroups(updatedGroups);
        }
    };

    const handleEditHawb = (idx) => {
        const packageToEdit = savedPackages[idx];
        setPackageGroups([{ ...packageToEdit }]);
        setEditIndex(idx);
        setPackageShow(true);
    };
    const isStepComplete = (stepName) => {
        switch (stepName) {
            case 'pick_up_check':
                return !!String(formData?.pick_up_check ?? '').trim();
            case 'warehouse_inbound_check':
                return !!String(formData?.warehouse_inbound_check ?? '').trim();
            // case 'checks_completed_check':
            //     return !!String(formData?.checks_completed_check ?? '').trim();
            case 'checks_completed_check':
                return formData?.checks_completed_check === '1';
            case 'order_picked_check':
                return !!String(formData?.order_picked_check ?? '').trim();
            case 'transport_planned_check':
                return !!String(formData?.transport_planned_check ?? '').trim();
            case 'warehouse_out_check':
                return !!String(formData?.warehouse_out_check ?? '').trim();
            default:
                return false;
        }
    };

    const handleSaveHawb = () => {
        for (let i = 0; i < packageGroups.length; i++) {
            const group = packageGroups[i];
            if (!group.number_of_packages || !group.length || !group.height) {
                toast.error(`Group ${i + 1}: Number of packages, Length, and Height are required!`);
                return;
            }
        }

        let updatedPackages;
        if (editIndex !== null) {
            updatedPackages = savedPackages.map((item, idx) =>
                idx === editIndex ? { ...packageGroups[0] } : item
            );
        } else {
            updatedPackages = [...savedPackages, ...packageGroups];
        }

        setSavedPackages(updatedPackages);
        setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
        setEditIndex(null);
        setPackageShow(false);

        toast.success(editIndex !== null ? "Package updated successfully!" : "Packages added successfully!");
    };


    const handleDeleteHawb = (idx) => {
        const updatedPackages = savedPackages.filter((_, i) => i !== idx);
        setSavedPackages(updatedPackages);

        if (editIndex === idx) {
            setPackageGroups([{ number_of_packages: '', length: '', width: '', height: '', gross_weight: '', volumetric_weight: '', chargeable_weight: '', total_freight_cost: '' }]);
            setEditIndex(null);
        }

        toast.success("Package deleted successfully!");
    };

    // Customer modal handlers
    const contactModalOpen = () => {
        setIsLoadingc(false);
        setCgridData({ Active: {} });
        setContactModal(true);
    };

    const handleAddLocation = () => {
        setLocationData({});
        setAddLocationModal(true);
    };

    const hideLocationModal = () => {
        setAddLocationModal(false);
        setLocationData({});
    };

    const handleLocationChange = (name, value) => {
        setLocationData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleLocationSave = async () => {
        if (!locationData.station || !locationData.location) {
            toast.error("Please fill all required fields.");
            return;
        }
        const payload = {
            ...(locationData?.id && { id: locationData?.id }),
            station: locationData.station,
            location: locationData.location
        };
        try {
            const res = await withRFSToken.post('forwarder-location/save', payload);
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                if (lgridRef.current && window?.$) {
                    window.$(lgridRef.current).jqxGrid('updatebounddata');
                }
                setAddLocationModal(false);
                setLocationData({});
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error sending request:', error);
        }
    };

    const handleLocationApply = () => {
        if (locationGridSelect.length == 0) {
            toast.error('Please select at least one location');
        } else if (locationGridSelect.length == 1) {
            setLocationModal(false);
            setFormData(prevData => ({
                ...prevData,
                location: locationGridSelect[0].location
            }));
            setLocationGridSelect([]);
        } else {
            toast.error('You can select one location at a time');
        }
    };

    const handleCustomerApply = () => {
        if (customerGridSelect.length === 0) {
            toast.error('Please select at least one customer');
        } else if (customerGridSelect.length === 1) {
            setContactModal(false);
            const customer = customerGridSelect[0];

            setQuotation(prev => ({
                ...prev,
                customer_id: customer.id,
                name: `${customer.name} - ${customer.customer_type}`,
                email: customer?.email,
                company: customer?.name,
                pickup_address: [
                    {
                        company_name: customer.name || '',
                        street_name: customer.street_name || '',
                        postal_code: customer.postal_code || '',
                        city: customer.city || '',
                        country: customer.country || '',
                    }
                ]
            }));

            setCustomerGridSelect([]);
        } else {
            toast.error('You can select one customer at a time');
        }
    };


    const handleSelect = (row) => {
        setCustomerGridSelect(row);
    };

    const handleButtonClick = async (button) => {
        if (button == 'remarks') { setActiveStep(2) }
        else if (button == 'attachment') {
            setActiveStep(1);
            if (!formData.id && formData.shipper) {
                try {
                    const res = await withRFSToken.post('shipment/save-export-shipment-record', formData);
                    if (res.data.response_code === 200) {
                        localStorage.setItem('SHEdit', JSON.stringify(res.data.response_data.id));
                        setFormData(res.data.response_data);
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            }
        }
        else { setActiveStep(0) }
        setSelectedButton(button);
    };

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
    }

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };
    const toggleAccordionItem = async (index, msg, pos) => {

        setExpandedKeys(prevKeys =>
            prevKeys.includes(index.toString())
                ? prevKeys.filter(key => key !== index.toString()) // Remove key to collapse
                : [...prevKeys, index.toString()] // Add key to expand
        );
    };

    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setSendData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }
    // Attachments Start

    // Attachments End
    // IMAGE UPLOAD START

    const handleDrop = (e) => {
        e.preventDefault();

        const droppedFiles = Array.from(e.dataTransfer.files);
        const selectedFiles = Array.from(e.dataTransfer.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    let newBase64Files;
                    if (uploadTarget) {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [uploadTarget] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    setSendData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
        // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        // getBase64(droppedFiles[0]);
    };

    const handleGetOrg = () => {
        setDisLoading(true);
        CallApi({
            endPoint: 'quotation/get-org-local-charges',
            method: 'get',
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    if (innerData) {
                        // setRecordId(innerData.record_id || null);
                        setQuotationFormData(innerData);
                    }
                    setDisLoading(false);
                } else {
                    toast.error("Error Fetching");
                    setDisLoading(false);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const handlelog = (id) => {
        CallApi({
            endPoint: `shipment-export/view-record/${id}`,
            method: 'get',
            onSuccess: (res) => {
                const resCode = res.data.response_code;
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const handleCalLocalCharges = () => {
        setDisLoading(true);

        const weight = parseFloat(totals.totalChargeableWeight) || null;
        const payload = {
            type: quotation?.shipment_type === "E" ? 'export' : quotation?.shipment_type === "I" ? 'import' : null,
            weight: weight,
        };

        // const extraHsValue = quotation?.shipment_type === "E" 
        //     ? quotationFormData.export_customs_extra_hs 
        //     : quotation?.shipment_type === "I" 
        //     ? quotationFormData.import_customs_extra_hs 
        //     : null;

        // if (extraHsValue && extraHsValue !== '0') {
        //     payload.extra_hs = parseInt(extraHsValue) || 0;
        // }

        CallApi({
            endPoint: 'quotation/get-org-local-charges',
            payload: payload,
            // method: 'get',
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    if (innerData) {
                        // setRecordId(innerData.record_id || null);
                        setGetLocalCharges(innerData);
                    }
                    setDisLoading(false);
                } else {
                    toast.error("Error Fetching");
                    setDisLoading(false);
                }
            },
            onError: (msg) => toast.error(msg)

        });

    }

    useEffect(() => {
        if (totals.totalGrossWeight && (quotationFormData.export_customs_extra_hs || quotationFormData.import_customs_extra_hs) && quotation?.shipment_type) {
            handleCalLocalCharges()
        } else {
            setGetLocalCharges({})
        }
    }, [totals.totalGrossWeight, savedPackages.length, quotationFormData.export_customs_extra_hs, quotationFormData.import_customs_extra_hs, quotation?.shipment_type])


    const handleQuotationChange = (field, value) => {
        setQuotationFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, pos) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        if (pos == 'R') {
            setRfiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        }
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);
            if (pos == 'R') {

                setSendData((prevFormData) => {
                    // const newFiles = [...prevFormData.files];
                    const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
                    newFiles.splice(index, 1);
                    return { ...prevFormData, files: newFiles };
                });
            }
            // Update local storage


            return newBase64Files;
        });
    };

    const imageModalUpload = () => {
        setShowModalUpload(true);
    }

    const closeModalUpload = () => {
        setShowModalUpload(false);
        setFiles([])
        setUploadTarget('');
        setBase64Files([]);
    }

    const handleBrowseFiles = (e, nam) => {
        e.preventDefault();
        if (nam) {
            if (fileInputRefs.current[nam]) {
                fileInputRefs.current[nam].click();
            }
        } else { fileInputRef.current.click(); }
    };
    const handleFileChange = (e, pos, chk) => {
        if (formData.id) {
            const selectedFiles = Array.from(e.target.files);
            const filesWithBase64 = [];
            let filesProcessed = 0;

            // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
            const existingBase64Files = formData?.base64Files || [];

            selectedFiles.forEach((file) => {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    if (file.size > 26214400) {
                        toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
                        return;
                    }
                    filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
                    filesProcessed += 1;
                    if (filesProcessed === selectedFiles.length) {
                        const newFiles = filesWithBase64.map((obj) => obj.file);
                        let newBase64Files;
                        if (pos === 'C') {
                            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                        } else {
                            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                        }

                        // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                        const mergedBase64Files = [...existingBase64Files, ...newBase64Files];


                        setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                        setBase64Files(mergedBase64Files);
                        if (pos == 'R') {
                            setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
                            setSendData((prevFormData) => {
                                const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                                return newFormData;
                            });
                        }

                    }
                };
                reader.readAsDataURL(file);
            });
        } else {
            toast.error('Please add Shipper first')
        }

    };
    const imageUpload = async () => {
        const payload = {
            shipmen_id: formData.id,
            shipmen_type: "export",
            attachments: base64Files
        }
        try {
            const res = await withRFSToken.post('shipment/upload-doc', payload);
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                setFormData(prevFormData => ({ ...prevFormData, attachments: res.data.response_data?.attachments }))
                setShowModalUpload(false);
                setFiles([])
                setUploadTarget('');
                setBase64Files([])
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
        }
    };
    const areAllChecksCompleted = () => {
        const requiredChecks = [
            'pick_up_check', 'warehouse_inbound_check', 'customs_document',
            'exa_prepared_by_kerry', 'documents', 'awb_instruction',
            'awb_draft_send', 'awb_approved', 'pre_alert_send', 'fwb_fhl', 'screening'
        ];
        // if (formData.sec_status !== 'K') {
        //     requiredChecks.push('screening');
        // }
        return requiredChecks.every(field =>
            formData[field] === '0' || formData[field] === '1'
        );
    };
    const handleInputChange = (name, value) => {
        if (name === 'master_airwaybill') {
            value = handleChange(value);
        }
        if (name === 'wms_nr') {
            if (typeof value === 'string') {
                try {
                    value = JSON.parse(value);
                } catch (e) {
                    value = value ? [value] : [];
                }
            }
            if (!Array.isArray(value)) {
                value = value ? [value] : [];
            }
        }
        if (name === 'all_currency') {
            if (value) {
                setFormData({
                    ...formData,
                    [name]: value,
                    air_freight_currency: value,
                    fuel_surcharge_currency: value,
                    security_surcharge_currency: value,
                    terminal_handling_fee_currency: value,
                    trucking_currency: value,
                    customs_clearance_currency: value,
                    security_scanning_currency: value,
                    handling_fee_currency: value,
                    packing_fee_currency: value,
                    profit_currency: value,
                });
            }
            return;
        }
        if (name === 'pick_up_check') {
            if (value === '1') {
                const now = new Date();
                const formattedDate = now.toLocaleString('sv-SE').slice(0, 16);
                setFormData({
                    ...formData,
                    pick_up_check: value,
                    pick_up: formattedDate,
                });
            } else {
                setFormData({
                    ...formData,
                    pick_up_check: value,
                    pick_up: '',
                });
            }
            return;
        }
        if (name === 'warehouse_inbound_check') {
            if (value === '1') {
                const now = new Date();
                const formattedDate = now.toLocaleString('sv-SE').slice(0, 16);
                setFormData({
                    ...formData,
                    warehouse_inbound_check: value,
                    warehouse_inbound: formattedDate,
                });
            } else {
                setFormData({
                    ...formData,
                    warehouse_inbound_check: value,
                    warehouse_inbound: '',
                });
            }
            return;
        }
        if (name === 'screening_planned') {
            const now = new Date();
            const formattedDate = now.toLocaleString('sv-SE').slice(0, 16);
            if (value === '1') {
                setFormData(prev => ({ ...prev, screening: '0', screening_date: '', screening_planned: '1', screening_planned_date: formattedDate, }));
            } else {
                setFormData({ ...formData, screening_planned: '0', screening_planned_date: '', screening: '0', screening_date: '', });
            }
            return;
        }
        if (name === 'screening') {
            const now = new Date();
            const formattedDate = now.toLocaleString('sv-SE').slice(0, 16);
            if (value === '1') {
                setFormData(prev => ({ ...prev, sec_status: 'S', screening: '1', screening_date: formattedDate, }));
            } else {
                setFormData({ ...formData, sec_status: 'U', screening: '0', screening_date: '', });
            }
            return;
        }
        if (name === 'sec_status') {
            if (value === 'S') {
                const now = new Date();
                const formattedDate = now.toLocaleString('sv-SE').slice(0, 16);
                setFormData({ ...formData, screening: '1', screening_date: formattedDate, sec_status: "S", screening_type: formData?.screening_type || '' });
            } else if (value === 'U') {
                setFormData({ ...formData, screening: '0', screening_date: '', screening_planned: '0', screening_planned_date: '', sec_status: value, screening_type: 'NSC' });
            } else if (value === 'K') {
                setFormData({ ...formData, screening: '0', screening_date: '', screening_planned: '0', screening_planned_date: '', sec_status: value, screening_type: 'SCO' });
            }
            return;
        }
        if (name === 'checks_completed_check') {
            if (value === '1') {
                if (!areAllChecksCompleted()) {
                    toast.info('Please complete all checks before marking Checks Completed.');
                    return;
                }
                const now = new Date();
                const formattedDate = now.toLocaleString('sv-SE').slice(0, 16);
                setFormData({
                    ...formData,
                    checks_completed_check: value,
                    checks_completed: formattedDate,
                });
            } else {
                setFormData({
                    ...formData,
                    checks_completed_check: value,
                    checks_completed: '',
                });
            }
            return;
        }
        if (name === 'dangerous_goods') {
            setFormData(prev => {
                const updated = { ...prev, dangerous_goods: value };
                if (!prev.latManualOverride && prev.flight_details?.length > 0 && prev.flight_details[0]?.eta) {
                    updated.flight_lat = calculateLAT(prev.flight_details[0].eta, value);
                }
                return updated;
            });
            return;
        }
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, '');
        let formattedValue = '';
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    const validateFormData = () => {
        let isValid = true;
        const awb = formData.master_airwaybill;
        if (!formData.shipper) {
            toast.error('Please add Shipper first');
            isValid = false;
        }
        if (awb && awb.length !== 13) {
            toast.error("The air way bill must be like 000-0000 0000");
            isValid = false;
        }
        if (formData.sec_status !== 'K' && !formData.screening) {
            toast.error("Please add Screening field");
            isValid = false;
        }
        return isValid;
    };
    const handleSubmit = async (stp) => {
        if (selectedTab == 'vwa') {
            handleUpdateQuotation();
            return;
        }
        if (validateFormData()) {
            let transData = {};
            if (activeStep === 2) {
                transData = { ...formData, remarks: sendData }
            } else {
                transData = formData
            }
            const { latManualOverride, ...transDataToSend } = transData;
            try {
                const res = await withRFSToken.post('shipment/save-export-shipment-record', transDataToSend);
                if (res.data.response_code === 200) {
                    if (stp === 'N') {
                        if (activeStep === 0) { handleButtonClick('attachment'); }
                        else if (activeStep === 1) { handleButtonClick('remarks'); }
                        setActiveStep(activeStep + 1);
                        setFormData(res.data.response_data);
                    } else {
                        toast.success(res.data.response_msg)
                        const backUrl = '/ForwarderShipments/ShipmentRecords';
                        window.location.href = backUrl;
                    }
                } else {
                    toast.error(res.data.response_msg)
                }
            } catch (error) {
                console.error('Error saving shipment record:', error);
            }
        } else {
            // toast.error('Please add Shipper first');
        }
    };

    const [typeModal, setTypeModal] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [modalData, setModalData] = useState({});
    const [typeData, setTypeData] = useState('');

    const handleOpenModal = (pos, data) => {
        setModalData(data);
        setTypeModal(true);
        setModalSection(pos);
        setTypeData(data.category[0])
    }
    const modalChange = (e) => {
        setTypeData(e.target.value);
    }
    const modalUpdate = async () => {
        if (modalSection === 'S') {
            if (typeData !== null) {
                const payload = {
                    shipmen_id: shId,
                    shipmen_type: 'export',
                    action_type: 'update',
                    file_id: modalData.file_id,
                    category: [typeData]
                }
                try {
                    const res = await withRFSToken.post('shipment/update-doc', payload);
                    if (res.data.response_code === 200) {
                        setFormData(res.data.response_data);
                        toast.success(res.data.response_msg)
                        setTypeModal(false);
                    } else {
                        toast.error(res.data.response_msg)
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            } else {
                toast.error('Please change the type first')
            }
        } else {
            const payload = {
                shipmen_id: shId,
                shipmen_type: 'export',
                action_type: 'delete',
                file_id: modalData.file_id
            }
            try {
                const res = await withRFSToken.post('shipment/update-doc', payload);
                if (res.data.response_code === 200) {
                    setFormData(res.data.response_data);
                    toast.success(res.data.response_msg)
                    setTypeModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            } catch (error) {
                console.error('Error saving shipment record:', error);
            }
        }

    }
    const [selectedTab, setSelectedTab] = useState('details');
    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                no: rows.length + 1,
                origin: '',
                rate: '',
                units: '',
                total: '',
                services: '',
                service_type: 'select',
            },
        ]);
    };
    const handleRowChange = (idx, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === idx) {
                let updatedRow = { ...row };
                if (field === 'services') {
                    const selectedService = stationRateData.find(item => item.services === value);
                    if (selectedService) {
                        updatedRow = {
                            ...updatedRow, services: selectedService.services, origin: selectedService.origin, destination: selectedService.destination,
                            rate: selectedService.rate, units: selectedService.units, total: selectedService.total
                        };
                    } else {
                        updatedRow.services = value;
                    }
                } else {
                    updatedRow[field] = value;
                }
                return updatedRow;
            }
            return row;
        });

        setRows(updatedRows);
    };

    const handleDeleteRow = (idx) => {
        if (rows.length === 1) return;
        const updatedRows = rows.filter((_, i) => i !== idx).map((row, i) => ({ ...row, no: i + 1 }));
        setRows(updatedRows);
    };
    const getGrandTotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.total) || 0), 0);

    const handleAddAFRow = () => {
        setAFRows([
            ...afRows,
            {
                no: afRows.length + 1,
                airline: '',
                product: '',
                to: '',
                via: '',
                freight: '',
                base: '',
                rate: '',
                fuel: '',
                risk: '',
                fees: '',
                freightAmount: '',
                surcharges: '',
                validity: '',
                total: '',
                showOptionalColumns: false,
            },
        ]);
    };

    const handleAFRowChange = (idx, field, value) => {
        const updatedRows = afRows.map((row, i) => {
            if (i === idx) {
                let updatedRow = { ...row, [field]: value };

                // Calculate freightAmount and total as rate * totalChargeableWeight
                if (field === 'rate' || field === 'total') {
                    const rate = field === 'rate' ? parseFloat(value) || 0 : parseFloat(updatedRow.rate) || 0;
                    const chargeableWeight = parseFloat(totals?.totalChargeableWeight) || 0;
                    const calculatedValue = rate * chargeableWeight;

                    updatedRow.freightAmount = calculatedValue.toFixed(2);
                    updatedRow.total = calculatedValue.toFixed(2);
                }

                return updatedRow;
            }
            return row;
        });

        setAFRows(updatedRows);
    };




    // Update helper for nested address arrays (pickup_address, deliver_address)
    const handleAddressChange = (key, field, value) => {
        setQuotation((prev) => {
            const existingArray = Array.isArray(prev?.[key]) ? [...prev[key]] : [];
            const firstEntry = { ...(existingArray[0] || {}), [field]: value };
            const updatedArray = existingArray.length > 0 ? [firstEntry, ...existingArray.slice(1)] : [firstEntry];
            return {
                ...prev,
                [key]: updatedArray,
            };
        });
    };

    // Parse Google place object into our address fields



    const handleDeleteAFRow = (idx) => {
        if (afRows.length === 1) return;
        const updatedRows = afRows.filter((_, i) => i !== idx).map((row, i) => ({ ...row, no: i + 1 }));
        setAFRows(updatedRows);
    };

    const getAFGrandTotal = () => afRows.reduce((sum, row) => sum + (parseFloat(row.total) || 0), 0);

    const normalizeAirport = (val) => (val && typeof val === 'object' && 'value' in val) ? val.value : (val || '');

    const handleUpdateQuotation = async () => {
        try {
            const services_charges = rows.map(r => ({
                ...r,
                origin: normalizeAirport(r.origin),
            }));
            const airfreight = afRows.map(r => ({
                ...r,
                to: normalizeAirport(r.to),
                via: normalizeAirport(r.via),
            }));

            const payload = {
                id: quotation.id,
                origin: quotation?.origin || '',
                destination: quotation?.destination || '',
                total_price: (parseFloat(getLocalCharges.total || 0) + getAFGrandTotal()).toFixed(2),
                customer_id: quotation?.customer_id || '',
                customer_type: quotation?.customer_type || '',
                shipment_type: quotation?.shipment_type || '',
                incoterm: quotation?.incoterm || '',
                // Expect arrays of objects for addresses
                pickup_address: Array.isArray(quotation?.pickup_address) ? quotation.pickup_address : [],
                deliver_address: Array.isArray(quotation?.deliver_address) ? quotation.deliver_address : [],
                // Use savedPackages as packages for submit
                packages: Array.isArray(savedPackages) ? savedPackages : [],
                services_charges,
                airfreight,
            };

            const res = await withRFSToken.post('quotation/add-update', payload);
            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.response_msg || 'Quotation updated');
                if (typeof goParent === "function") {
                    goParent();
                } else {
                    console.warn("goParent is not a function", goParent);
                }
            } else {
                toast.error(res?.data?.response_msg || 'Failed to update quotation');
            }
        } catch (err) {
            console.error('Failed to update quotation', err);
            toast.error('Failed to update quotation');
        }
    };

    const handleVwaInputChange = (name, value) => {
        setQuotation(prev => {
            let updatedQuotation = { ...prev, [name]: value };
            if (name === 'shipment_type') {
                if (value === 'E') {
                    updatedQuotation.destination = '';
                    updatedQuotation.origin = 'AMS';
                    fetchStationRate('export', true);
                } else if (value === 'I') {
                    updatedQuotation.destination = 'AMS';
                    updatedQuotation.origin = '';
                    fetchStationRate('import', true);
                }
            }
            return updatedQuotation;
        });
    };
    const handleConfirmDelete = async () => {
        setShowDeleteConfirm(false);
        try {
            const res = await withRFSToken.post("shipment/disconnect-airway-bill", { take_in_ids: deleteIds, });
            if (res.data.response_code === 200) {
                toast.success("Record deleted successfully" || res.data.response_msg);
                setDeleteIds([]);
                window.location.reload()
            } else {
                toast.error(res.data.response_msg || "Failed to delete record");
            }
        } catch (error) {
            console.error("Error deleting record:", error);
            toast.error("Failed to delete record");
        }
    };

    useEffect(() => {
        if (formData?.sec_status === 'K' && formData?.screening_type !== 'SCO') {
            setFormData(prev => ({ ...prev, screening_type: 'SCO' }));
        } else if (formData?.sec_status === 'U' && formData?.screening_type !== 'NSC') {
            setFormData(prev => ({ ...prev, screening_type: 'NSC' }));
        }
    }, [formData?.sec_status]);

    return (
        <>
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <div className='shipment_tab'>
                <div className="mt-3">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="viewbooks" style={{}}>
                                <h4 className='d-flex align-items-center justify-content-between'>Export Record - {formData.cargohub_id} </h4>
                                <p><span><b>Created On :</b> </span>{formData?.created_at?.split('T')[0].split('-').reverse().join('-')}</p>
                                <p className='d-flex justify-content-between'>
                                    <span><b>Status : <span style={{ color: '#FC8430' }}>
                                        {shId && formData.status == 'A' ? 'Accepted' : 'Open'}
                                    </span></b></span>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="viewbooks" style={{}}>
                                {/* Progress Bar */}
                                <div className="mt-1">
                                    <div className="d-flex justify-content-between align-items-start position-relative">

                                        <div className="Progress_Line" style={{ backgroundColor: '#ccc' }}></div>
                                        {/* Step 1 - ETA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('pick_up_check') ? "step_complete" : "step_incomplete"} style={{}}>
                                                1
                                            </div>
                                            <div className={'text-center progress_status_txt_incomplete'}>
                                                <div>Shipper Pickup</div>
                                                {/* <div>{formData?.pick_up_check ? formData?.pick_up_check.replace('T', ' ') : ''}</div> */}
                                            </div>
                                        </div>

                                        {/* Step 2 - ATA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('warehouse_inbound_check') ? "step_complete" : "step_incomplete"} style={{}}>
                                                2
                                            </div>
                                            <div className={'text-center progress_status_txt_incomplete'}>
                                                <div>Warehouse In</div>
                                                {/* <div>{formData?.warehouse_inbound_check ? formData?.warehouse_inbound_check.replace('T', ' ') : ''}</div> */}
                                            </div>
                                        </div>

                                        {/* Step 3 - NOA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('checks_completed_check') ? "step_complete" : "step_incomplete"} style={{}}>
                                                3
                                            </div>
                                            <div className={'text-center progress_status_txt_incomplete'}>
                                                <div>Checks Completed</div>
                                                {/* <div>{formData?.checks_completed_check ? formData?.checks_completed_check.replace('T', ' ') : ''}</div> */}
                                            </div>
                                        </div>

                                        {/* Step 4 - Pickup Airline */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('eta') ? "step_complete" : "step_incomplete"} style={{}}>
                                                4
                                            </div>
                                            <div className={'text-center progress_status_txt_incomplete'}>
                                                <div>Order Picked</div>
                                                {/* <div>{formData?.p || ''}</div> */}
                                            </div>
                                        </div>

                                        {/* Step 5 - Warehouse In */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('eta') ? "step_complete" : "step_incomplete"} style={{}}>
                                                5
                                            </div>
                                            <div className={'text-center progress_status_txt_incomplete'}>
                                                <div>Transport Planned</div>
                                                {/* <div>{formData?.w || ''}</div> */}
                                            </div>
                                        </div>

                                        {/* Step 6 - Warehouse Out */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('eta') ? "step_complete" : "step_incomplete"} style={{}}>
                                                6
                                            </div>
                                            <div className={'text-center progress_status_txt_incomplete'}>
                                                <div>Warehouse Out</div>
                                                {/* <div>{formData.w || ''}</div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Row className='mt-3'>
                    <Col sm='3'>
                        <div className='add_shipment'>
                            <button className={selectedButton === 'general' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('general')}>
                                <img src={selectedButton === 'general' ? AssetsIconw : AssetsIcon} /> <span>General</span>
                            </button>
                            <button className={selectedButton === 'attachment' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('attachment')}>
                                <img src={selectedButton === 'attachment' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                            </button>
                            <button className={selectedButton === 'remarks' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('remarks')}>
                                <img src={selectedButton === 'remarks' ? AssetsIconw : AssetsIcon} /> <span>Remarks ({formData?.remarks?.length || 0})</span>
                            </button>
                        </div>
                        {selectedButton === 'general' &&
                            <div className='flbg mt-4 ra_label'>
                                <div className="ship_head">
                                    <h4>Update Status</h4>
                                </div>
                                <Form.Group className="mb-2">
                                    <Form.Label>Assigned User </Form.Label>
                                    <Select
                                        options={userList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                assigned_to: selected.value
                                            });
                                        }}
                                        placeholder="User"
                                        className='rfs_autoslct'
                                        name="assigned_to"
                                        value={formData.assigned_to
                                            ? userList.find(option => option.value === formData.assigned_to)
                                            : null}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Department </Form.Label>
                                    <Select
                                        options={departmentList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                setting_department: selected.value,
                                                setting_status: null
                                            });
                                            const transformedData = selected.status
                                                ? selected.status.map((item) => ({
                                                    value: item.id,
                                                    label: item.name,
                                                }))
                                                : [];
                                            setStatusList(transformedData);
                                        }}
                                        placeholder="Department"
                                        className='rfs_autoslct'
                                        name="setting_department"
                                        value={formData.setting_department
                                            ? departmentList.find(option => option.value === formData.setting_department)
                                            : null}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Status </Form.Label>
                                    <Select
                                        options={statusList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                setting_status: selected.value
                                            });
                                        }}
                                        placeholder="Status"
                                        className='rfs_autoslct'
                                        name="setting_status"
                                        value={formData.setting_status
                                            ? statusList.find(option => option.value === formData.setting_status)
                                            : null}
                                    />
                                </Form.Group>
                            </div>
                        }

                        {selectedButton === 'attachment' &&
                            <div className='flbg mt-4'>

                                <div className="ship_head">
                                    <h4>Document Checklist</h4>
                                </div>
                                <ul className="dock_check">
                                    {["Invoice", "Packinglist", "Emails", "HAWB", "MAWB", "Manifest", "Customs", "Proposal", "Other"].map((name) => (
                                        <li key={name}>
                                            <span>
                                                <Form.Check
                                                    inline
                                                    label={name}
                                                    value={name}
                                                    name="group1"
                                                    checked={formData?.attachments?.some(chk => chk.category && chk.category.includes(name)) || false}
                                                />
                                            </span>
                                            <span>
                                                <img src={Uploadn} onClick={() => { setUploadTarget(name); setShowModalUpload(true); }} />
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        }
                    </Col>
                    <Col sm='9'>
                        <div className='mb-3 position-relative'>
                            {(Boolean(shId) || Boolean(addexp)) && (
                                <button className={`exportbtn me-3${selectedTab === 'details' ? ' active' : ''}`} onClick={() => { setSelectedTab('details'); setSelectedButton('general') }}>
                                    <img src={selectedTab === 'details' ? AssetsIconw : AssetsIcon} /> <span>Details</span>
                                </button>)}
                            <button className={`exportbtn me-3${selectedTab === 'vwa' ? ' active' : ''}`} onClick={() => { setSelectedTab('vwa'); setSelectedButton('general'); fetchQuotation(quotationId || localStorage.getItem("SHEdit"));; setDisLoading(true); }}>
                                <img src={selectedTab === 'vwa' ? AssetsIconw : AssetsIcon} /> <span>Quotation</span>
                            </button>

                            <span className="forwd_submit">
                                <button onClick={() => {
                                    const backUrl = localStorage.getItem('ccbackUrl') || '/ForwarderShipments/ShipmentRecords';
                                    localStorage.removeItem('AddExportInitQuotation');
                                    if (backUrl === '/Quotation') {
                                        localStorage.removeItem('QUTpage');
                                    }
                                    window.location.href = backUrl;
                                }} className="stk_close">
                                    <FontAwesomeIcon icon={faTimes} /> Close
                                </button>

                                <button onClick={() => {
                                    if (selectedTab === 'vwa' && isVwaReadOnly) { setIsVwaReadOnly(false); return; }
                                    handleSubmit("S");
                                }} className="stk_view">
                                    <FontAwesomeIcon icon={selectedTab === 'vwa' && isVwaReadOnly ? faPencilAlt : (shId ? faPencilAlt : faPaperPlane)} className="pe-1" />
                                    {selectedTab === 'vwa' && isVwaReadOnly ? 'Edit' : (shId ? "Update" : "Submit")}
                                </button>

                            </span>

                        </div>
                        {(selectedButton === 'general' && selectedTab === 'details') &&
                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Details</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Master AirwayBill :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className=''
                                                        name='master_airwaybill'
                                                        value={formData?.master_airwaybill || ''}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>JOB nr :</span>
                                                <span>
                                                    <Form.Control type="text" className='' name='job_nr' value={formData?.job_nr || ''} onChange={(e) => handleInputChange('job_nr', e.target.value)} readOnly />
                                                </span>
                                            </li>
                                            <li>
                                                <span>HAWB :</span>
                                                <span>
                                                    <Form.Control type="text" className='' name='hawb' value={formData?.hawb || ''} onChange={(e) => handleInputChange('hawb', e.target.value)} />
                                                </span>
                                            </li>
                                            <li className="row">
                                                <div className="col-md-6">
                                                    <Form.Group className='d-flex align-items-center'>
                                                        <Form.Label column sm={6} className='me-1'>
                                                            Custom Status :
                                                        </Form.Label>

                                                        <Col>
                                                            <Select
                                                                options={customStatus}
                                                                className="autoslct w-100"
                                                                name="custom_code"
                                                                value={customStatus.find(
                                                                    (option) => option.value === formData?.custom_code
                                                                )}
                                                                onChange={(option) =>
                                                                    handleInputChange("custom_code", option?.value || "")
                                                                }
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-md-6">
                                                    <Form.Group className='d-flex align-items-center'>
                                                        <Form.Label column sm={6}>
                                                            Security Code :
                                                        </Form.Label>

                                                        <Col>
                                                            <Select
                                                                options={securityStatus}
                                                                className="autoslct w-100"
                                                                name="screening_type"
                                                                value={securityStatus.find(
                                                                    (option) => option.value === formData?.screening_type
                                                                ) || null}
                                                                onChange={(option) =>
                                                                    handleInputChange("screening_type", option?.value || "")
                                                                }
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </div>
                                            </li>
                                            <li>
                                                <span>Incoterm :</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        placeholder="--"
                                                        className="autoslct w-100"
                                                        name="incoterm"
                                                        value={incotermOption?.find(option => option.value === formData?.incoterm) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex mb-2'>
                                                <span>Security : <span>*</span></span>
                                                <span>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            type="radio"
                                                            label="Known"
                                                            id="sec-1"
                                                            name="sec_status"
                                                            value="K"
                                                            checked={formData?.sec_status === "K"}
                                                            onChange={() => handleInputChange('sec_status', 'K')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            type="radio"
                                                            label="Unknown"
                                                            id="sec-2"
                                                            name="sec_status"
                                                            value="U"
                                                            checked={formData?.sec_status == "U"}
                                                            onChange={() => handleInputChange('sec_status', 'U')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            type="radio"
                                                            label="Screened"
                                                            id="sec-3"
                                                            name="sec_status"
                                                            value="S"
                                                            checked={formData?.sec_status == "S"}
                                                            onChange={() => handleInputChange('sec_status', 'S')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        {/* <p className="ms-2 mb-0">
                                                            {formData?.sec_status === "K"
                                                                ? "Screened"
                                                                : formData?.sec_status === "U"
                                                                ? "Screening Required"
                                                                : ""}
                                                        </p> */}
                                                    </div>
                                                </span>
                                            </li>
                                            <li className='d-flex mb-2'>
                                                <span>Dangerous Goods :</span>
                                                <span>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            type="radio"
                                                            label="Yes"
                                                            id="dg-1"
                                                            name="dangerous_goods"
                                                            value="true"
                                                            checked={formData?.dangerous_goods == 1}
                                                            onChange={(e) => handleInputChange('dangerous_goods', 1)}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            type="radio"
                                                            label="No"
                                                            id="dg-2"
                                                            name="dangerous_goods"
                                                            value="false"
                                                            checked={formData?.dangerous_goods == 0}
                                                            onChange={(e) => handleInputChange('dangerous_goods', 0)}
                                                            style={{ width: '100px' }}
                                                        />
                                                        {formData?.dangerous_goods == 1 && formData?.un_number && (
                                                            <p className="mb-0 ms-3">
                                                                UN No:{" "}
                                                                <strong>
                                                                    {getDg.find(
                                                                        item => String(item.value) === String(formData.un_number)
                                                                    )?.value}
                                                                </strong>
                                                            </p>
                                                        )}
                                                    </div>
                                                    {formData?.dangerous_goods == 1 &&
                                                        <>
                                                            {/* <Form.Label>UN Number</Form.Label> */}
                                                            <Select
                                                                options={getDg}
                                                                onChange={(e) => handleInputChange('un_number', e.value)}
                                                                placeholder="Dangerous Goods"
                                                                className="autoslct w-100"
                                                                name="un_number"
                                                                value={getDg.find(option => option.value === formData?.un_number) || ''}
                                                            />
                                                        </>
                                                    }
                                                </span>
                                            </li>
                                            <li className='d-flex mb-2'>
                                                <span>Temp Controlled :</span>
                                                <span>
                                                    <div className='d-flex'>
                                                        <Form.Check
                                                            type="radio"
                                                            label="Yes"
                                                            id="tc-1"
                                                            name="temp_controlled"
                                                            value="true"
                                                            checked={formData?.temp_controlled == 1}
                                                            onChange={(e) => handleInputChange('temp_controlled', 1)}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            type="radio"
                                                            label="No"
                                                            id="tc-2"
                                                            name="temp_controlled"
                                                            value="false"
                                                            checked={formData?.temp_controlled == 0}
                                                            onChange={(e) => handleInputChange('temp_controlled', 0)}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <span>Destination Airport :</span>
                                                <span>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(e) => handleInputChange('destination_airport', e.value)}
                                                        placeholder="Destination"
                                                        className="autoslct w-100"
                                                        name="destination_airport"
                                                        value={getDestination.find(option => option.value === formData?.destination_airport) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <br></br>
                                            <hr />
                                            <br></br>

                                            {/* <li>
                                                <span>Label ID :</span>
                                                <span>
                                                    <Select
                                                        options={getWms}
                                                        isMulti
                                                        onChange={(selectedOptions) =>
                                                            handleInputChange(
                                                                'wms_nr',
                                                                selectedOptions?.map(opt => opt.value) || []
                                                            )
                                                        }
                                                        placeholder="--"
                                                        className="autoslct w-100"
                                                        name="wms_nr"
                                                        value={getWms?.filter(option =>
                                                            formData?.wms_nr?.includes(option.value)
                                                        ) || []}
                                                    />
                                                </span>
                                            </li> */}

                                            <li>
                                                <span>Shipper : <span>*</span></span>
                                                <span>
                                                    <Form.Control type="text" className='' name='shipper' value={formData?.shipper || ''} onChange={(e) => handleInputChange('shipper', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipper City:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="shipper_station"
                                                        value={formData?.shipper_station || ''}
                                                        onChange={(e) => handleInputChange('shipper_station', e.target.value)}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Shipper Address:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="shipper_location"
                                                        value={formData?.shipper_location || ''}
                                                        onChange={(e) => handleInputChange('shipper_location', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <br></br>
                                            <li>
                                                <span>Consignee :</span>
                                                <span>
                                                    <Form.Control type="text" className='' name='consignee' value={formData?.consignee || ''} onChange={(e) => handleInputChange('consignee', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Consignee City:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="consignee_station"
                                                        value={formData?.consignee_station || ''}
                                                        onChange={(e) => handleInputChange('consignee_station', e.target.value)}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Consignee Address:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="consignee_location"
                                                        value={formData?.consignee_location || ''}
                                                        onChange={(e) => handleInputChange('consignee_location', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <br></br>
                                            <hr />
                                            <br></br>
                                            {/* <li>
                                                <span>Station :</span>
                                                <span>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(e) => handleInputChange('station', e.value)}
                                                        value={getDestination.find(opt => opt.value === formData?.station) || ''}
                                                        className="w-100" />
                                                </span>
                                            </li> */}
                                            {/* <li>
                                                <span>Custom Status :</span>
                                                <span>
                                                    <Select
                                                        options={customStatus}
                                                        onChange={(e) => handleInputChange('custom_status', e.value)}
                                                        value={customStatus.find(opt => opt.value === formData?.custom_status) || ''}
                                                        className="w-100" />
                                                </span>
                                            </li> */}
                                            {/* <li>
                                                <span>Screening Type : </span>
                                                <span>
                                                    <Form.Control type="text" className='' name='shipper' value={formData?.screening_type || ''} onChange={(e) => handleInputChange('screening_type', e.target.value)} />
                                                </span>
                                            </li> */}

                                            {/* <li>
                                                <span>Reference :</span>
                                                <span>
                                                    <Form.Control type="text" className='' name='reference' value={formData?.reference || ''} onChange={(e) => handleInputChange('reference', e.target.value)} />
                                                </span>
                                            </li> */}

                                            <li className="row">
                                                <div className="col-md-6">
                                                    <Form.Group as={Row} className="">
                                                        <Form.Label column sm={6}>
                                                            Pieces :
                                                        </Form.Label>

                                                        <Col sm={5}>
                                                            <Form.Control
                                                                type="text"
                                                                name="pieces"
                                                                value={formData?.pieces || ""}
                                                                onChange={(e) => handleInputChange("pieces", e.target.value)}
                                                                className='export_pieces_input'
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-md-6 details_new grs-wt">
                                                    <Form.Group as={Row} className="">
                                                        <Form.Label column sm={5} className="labe_text mb-0">
                                                            Gross Weight :
                                                        </Form.Label>
                                                        <Col sm={6}>
                                                            <Form.Control
                                                                type="text"
                                                                name="gross_weight"
                                                                value={formData?.gross_weight || ""}
                                                                onChange={(e) => handleInputChange("gross_weight", e.target.value)}
                                                            />
                                                        </Col>

                                                    </Form.Group>
                                                </div>
                                            </li>

                                            <li className='d-flex'>
                                                <span>Dimensions :</span>
                                                <span>
                                                    {/* <Form.Control type="text" className='' name='dimensions' value={formData?.dimensions || ''} onChange={(e) => handleInputChange('dimensions', e.target.value)} /> */}
                                                    {formData?.dimensions?.map((data, index) => (
                                                        <div className='flex_gap'>
                                                            <div>
                                                                <Form.Label>Pieces</Form.Label>
                                                                <Form.Control type="text" placeholder=""
                                                                    value={data.pieces}
                                                                    onChange={(e) => handleDnChange(data.id, 'pieces', e.target.value)}
                                                                />
                                                            </div>
                                                            <div>
                                                                <Form.Label>Lenght</Form.Label>
                                                                <Form.Control type="text" placeholder=""
                                                                    value={data.length}
                                                                    onChange={(e) => handleDnChange(data.id, 'length', e.target.value)}
                                                                />
                                                            </div>
                                                            <div>
                                                                <Form.Label>Width</Form.Label>
                                                                <Form.Control type="text" placeholder=""
                                                                    value={data.width}
                                                                    onChange={(e) => handleDnChange(data.id, 'width', e.target.value)}
                                                                />
                                                            </div>
                                                            <div>
                                                                <Form.Label>Height</Form.Label>
                                                                <Form.Control type="text" placeholder=""
                                                                    value={data.height}
                                                                    onChange={(e) => handleDnChange(data.id, 'height', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className='imag_trash ms-0'>
                                                                {formData.dimensions.length > 1 && (
                                                                    <img src={Trash} alt='' onClick={() => removeDimension(data.id)} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    <div className='text-end mt-2 fwr_customer_add'>
                                                        <Button variant="primary" onClick={addDimension}>+ Add</Button>
                                                    </div>
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Volume Weight :</span><span>
                                                    <Form.Control type="text" className='' name='volume_weight' value={formData?.volume_weight || ''} onChange={(e) => handleInputChange('volume_weight', e.target.value)} />
                                                </span>
                                            </li> */}
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details mrn-input'>
                                        <div className='ship_head'>
                                            <h4>Flight Details</h4>
                                        </div>
                                        {formData?.flight_details?.map((data, index) => (
                                            <div className='flight_section mb-3'>
                                                <div className='flex_gap'>
                                                    <h4>Flight {index + 1}</h4>
                                                    <div className='imag_trash ms-0 mt-0 align-items-center'>
                                                        {formData.flight_details.length > 1 && (
                                                            <img src={Trash} alt='' onClick={() => removeFlight(data.id)} />
                                                        )}
                                                    </div>
                                                </div>

                                                <div className='flex_gap  mb-2'>
                                                    <div>
                                                        <Form.Label>Flight Number</Form.Label>
                                                        <div className='flex_gap'>
                                                            <Select
                                                                options={getOwnerCodes}
                                                                onChange={(e) => handleFlChange(data.id, 'flight_code', e.value)}
                                                                placeholder="flight"
                                                                className="autoslct"
                                                                name="flight_code"
                                                                value={getOwnerCodes.find(option => option.value === data?.flight_code) || ''}
                                                            />
                                                            <Form.Control type="text" className='fl_wd' placeholder=""
                                                                value={data.flight_number}
                                                                onChange={(e) => handleFlChange(data.id, 'flight_number', e.target.value)}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className='md_flight'>
                                                        <Form.Label>Flight Date</Form.Label>
                                                        <Form.Control type="date" placeholder=""
                                                            value={data.flight_date}
                                                            onChange={(e) => handleFlChange(data.id, 'flight_date', e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='flight_origin'>
                                                        <Form.Label>Origin</Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(e) => handleFlChange(data.id, 'origin', e.value)}
                                                            placeholder="origin"
                                                            className="autoslct"
                                                            name="origin"
                                                            value={getDestination.find(option => option.value === data?.origin) || ''}
                                                        />
                                                    </div>
                                                    <div className='flight_desti'>
                                                        <Form.Label>Destination</Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(e) => handleFlChange(data.id, 'destination', e.value)}
                                                            placeholder="Destination"
                                                            className="autoslct"
                                                            name="destination"
                                                            value={getDestination.find(option => option.value === data?.destination) || ''}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='flex_gap mb-2'>
                                                    <div className='w-50'>
                                                        <Form.Label>ETD</Form.Label>
                                                        <Form.Control type="datetime-local" placeholder=""
                                                            value={data.eta} min={getTodayDateTime(null, 'DATETIME_LOCAL')}
                                                            onChange={(e) => handleFlChange(data.id, 'eta', e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='w-50'>
                                                        <Form.Label>ATD</Form.Label>
                                                        <Form.Control type="datetime-local" placeholder=""
                                                            value={data.ata} min={getTodayDateTime(null, 'DATETIME_LOCAL')}
                                                            onChange={(e) => handleFlChange(data.id, 'ata', e.target.value)}
                                                        />
                                                    </div>

                                                </div>
                                                {/* {index === 0 &&
                                                    <div className='flex_gap  mb-2'>
                                                        <div className='w-50'>
                                                            <Form.Label>LAT (Latest Acceptance Time)</Form.Label>
                                                            <Form.Control type="datetime-local" placeholder=""
                                                                value={formData?.flight_lat}
                                                                onChange={(e) => handleInputChange('flight_lat', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='w-50'>
                                                            <Form.Label>Ground Handler</Form.Label>
                                                            <Select
                                                                options={groundHandlerOption}
                                                                onChange={(e) => handleInputChange('ground_handler', e.value)}
                                                                placeholder="--"
                                                                className="autoslct w-100"
                                                                name="ground_handler"
                                                                value={groundHandlerOption?.find(option => option.value == formData?.ground_handler) || ''}
                                                            />
                                                        </div>
                                                    </div>
                                                } */}
                                            </div>
                                        ))}

                                        <div className='text-end mt-2 dimension_add'>
                                            <Button variant="primary" onClick={addFlight}>+ Add</Button>
                                        </div>

                                        <ul>
                                            <li>
                                                <Form.Label className="fw-bold">LAT (Latest Acceptance Time)</Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    value={formData?.flight_lat}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            flight_lat: value,
                                                            latManualOverride: true,
                                                        }));
                                                    }}
                                                />
                                            </li>
                                            <li>
                                                <Form.Label>Ground Handler</Form.Label>
                                                <Select
                                                    options={groundHandlerOption}
                                                    onChange={(e) => handleInputChange('ground_handler', e.value)}
                                                    placeholder="--"
                                                    className="autoslct w-100"
                                                    name="ground_handler"
                                                    value={groundHandlerOption?.find(option => option.value == formData?.ground_handler) || ''}
                                                />
                                            </li>
                                        </ul>
                                        {/* </div>
                                     <div className='flbg details'> */}
                                        <div className='ship_head'>
                                            <h4>Checks</h4>
                                        </div>
                                        <ul className='checks'>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Shipper Pickup :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="pick_up_check"
                                                            checked={formData.pick_up_check == '1'}
                                                            onChange={() => handleInputChange('pick_up_check', '1')}
                                                            style={{ width: '100px' }}
                                                        />

                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="pick_up_check"
                                                            checked={formData.pick_up_check == '0'}
                                                            onChange={() => handleInputChange('pick_up_check', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="pick_up"
                                                        value={formData?.pick_up}
                                                        onChange={(e) => handleInputChange('pick_up', e.target.value)}
                                                        style={{ maxWidth: '230px' }}
                                                    />

                                                </span>
                                            </li>

                                            <li>
                                                <span className="d-flex align-items-center  justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Warehouse Inbound :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="warehouse_inbound_check"
                                                            checked={formData.warehouse_inbound_check == '1'}
                                                            onChange={() => handleInputChange('warehouse_inbound_check', '1')}
                                                            style={{ width: '100px' }}
                                                        />

                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="warehouse_inbound_check"
                                                            checked={formData.warehouse_inbound_check == '0'}
                                                            onChange={() => handleInputChange('warehouse_inbound_check', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="warehouse_inbound"
                                                        value={formData?.warehouse_inbound}
                                                        onChange={(e) => handleInputChange('warehouse_inbound', e.target.value)}
                                                        style={{ maxWidth: '230px' }}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Screening Planned : {formData?.sec_status != 'K' ? <span>*</span> : ''}</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="screening_planned"
                                                            checked={formData.screening_planned == '1'}
                                                            onChange={() => handleInputChange('screening_planned', '1')}
                                                            style={{ width: '100px' }}
                                                        />

                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="screening_planned"
                                                            checked={formData.screening_planned == '0'}
                                                            onChange={() => handleInputChange('screening_planned', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="screening_planned_date"
                                                        value={formData?.screening_planned_date}
                                                        onChange={(e) => handleInputChange('screening_planned_date', e.target.value)}
                                                        style={{ maxWidth: '230px' }}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Screened : {formData?.sec_status != 'K' ? <span>*</span> : ''}</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="screening"
                                                            checked={formData.screening == '1'}
                                                            onChange={() => handleInputChange('screening', '1')}
                                                            style={{ width: '100px' }}
                                                        />

                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="screening"
                                                            checked={formData.screening == '0'}
                                                            onChange={() => handleInputChange('screening', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="screening_date"
                                                        value={formData?.screening_date}
                                                        onChange={(e) => handleInputChange('screening_date', e.target.value)}
                                                        style={{ maxWidth: '230px' }}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li className=''>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Security :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Known"
                                                            id="Known-1"
                                                            name="sec_status"
                                                            value="K"
                                                            checked={formData?.sec_status === "K"}
                                                            onChange={(e) => handleInputChange('sec_status', 'K')}
                                                            className='mr-n'
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Unknown"
                                                            id="Known-2"
                                                            name="sec_status"
                                                            value="U"
                                                            checked={formData?.sec_status === "U"}
                                                            onChange={(e) => handleInputChange('sec_status', 'U')}
                                                        />
                                                    </span>
                                                </span>
                                            </li> */}

                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Customs Document :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="customs_document-1"
                                                            name="customs_document"
                                                            value="true"
                                                            checked={formData?.customs_document == "1"}
                                                            onChange={(e) => handleInputChange('customs_document', "1")}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="customs_document-2"
                                                            name="customs_document"
                                                            value="false"
                                                            checked={formData?.customs_document == "0"}
                                                            onChange={(e) => handleInputChange('customs_document', "0")}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>

                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Ex-a Prepared :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="exa_prepared_by_kerry-1"
                                                            name="exa_prepared_by_kerry"
                                                            value="true"
                                                            checked={formData?.exa_prepared_by_kerry == "1"}
                                                            onChange={(e) => handleInputChange('exa_prepared_by_kerry', '1')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="exa_prepared_by_kerry-2"
                                                            name="exa_prepared_by_kerry"
                                                            value="false"
                                                            checked={formData?.exa_prepared_by_kerry == "0"}
                                                            onChange={(e) => handleInputChange('exa_prepared_by_kerry', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                    {formData?.exa_prepared_by_kerry == "1" && (
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                name="mrn_no"
                                                                value={formData?.mrn_no || ""}
                                                                onChange={(e) =>
                                                                    handleInputChange("mrn_no", e.target.value)
                                                                }
                                                                placeholder="Enter MRN No"
                                                                className='mrn-inputs'
                                                            />
                                                        </>
                                                    )}
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Documents :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="documents-1"
                                                            name="documents"
                                                            value="true"
                                                            checked={formData?.documents === "1"}
                                                            onChange={(e) => handleInputChange('documents', '1')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="documents-2"
                                                            name="documents"
                                                            value="false"
                                                            checked={formData?.documents === "0"}
                                                            onChange={(e) => handleInputChange('documents', '0')}
                                                            style={{ width: '100px' }}
                                                        />

                                                    </span>
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>AWB Instruction :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="awb_instruction-1"
                                                            name="awb_instruction"
                                                            value="true"
                                                            checked={formData?.awb_instruction === "1"}
                                                            onChange={(e) => handleInputChange('awb_instruction', '1')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="awb_instruction-2"
                                                            name="awb_instruction"
                                                            value="false"
                                                            checked={formData?.awb_instruction === "0"}
                                                            onChange={(e) => handleInputChange('awb_instruction', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>AWB Draft Send :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="awb_draft_send-1"
                                                            name="awb_draft_send"
                                                            value="true"
                                                            checked={formData?.awb_draft_send === "1"}
                                                            onChange={(e) => handleInputChange('awb_draft_send', '1')}
                                                            style={{ width: '100px' }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="awb_draft_send-2"
                                                            name="awb_draft_send"
                                                            value="false"
                                                            checked={formData?.awb_draft_send === "0"}
                                                            onChange={(e) => handleInputChange('awb_draft_send', '0')}
                                                            style={{ width: '100px' }}
                                                        />
                                                    </span>
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>AWB Approved :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="awb_approved-1"
                                                            name="awb_approved"
                                                            value="true"
                                                            checked={formData?.awb_approved === "1"}
                                                            onChange={(e) => handleInputChange('awb_approved', '1')}
                                                            style={{ width: "100px" }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="awb_approved-2"
                                                            name="awb_approved"
                                                            value="false"
                                                            checked={formData?.awb_approved === "0"}
                                                            onChange={(e) => handleInputChange('awb_approved', '0')}
                                                            style={{ width: "100px" }}
                                                        />
                                                    </span>
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Pre-Alert Send :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="pre_alert_send-1"
                                                            name="pre_alert_send"
                                                            value="true"
                                                            checked={formData?.pre_alert_send === "1"}
                                                            onChange={(e) => handleInputChange('pre_alert_send', '1')}
                                                            style={{ width: "100px" }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="pre_alert_send-2"
                                                            name="pre_alert_send"
                                                            value="false"
                                                            checked={formData?.pre_alert_send === "0"}
                                                            onChange={(e) => handleInputChange('pre_alert_send', '0')}
                                                            style={{ width: "100px" }}
                                                        />
                                                    </span>
                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>FWB + FHL :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            id="fwb_fhl-1"
                                                            name="fwb_fhl"
                                                            value="true"
                                                            checked={formData?.fwb_fhl === "1"}
                                                            onChange={(e) => handleInputChange('fwb_fhl', '1')}
                                                            style={{ width: "100px" }}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            id="fwb_fhl-2"
                                                            name="fwb_fhl"
                                                            value="false"
                                                            checked={formData?.fwb_fhl === "0"}
                                                            onChange={(e) => handleInputChange('fwb_fhl', '0')}
                                                            style={{ width: "100px" }}
                                                        />
                                                    </span>

                                                </span>
                                            </li>
                                            <li>
                                                <span className="d-flex align-items-center justify-content-between gap-3">
                                                    <span style={{ minWidth: '180px', color: 'inherit' }}>Checks Completed :</span>
                                                    <span className='d-flex' style={{ minWidth: '220px' }}>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="checks_completed_check"
                                                            checked={formData.checks_completed_check == '1'}
                                                            onChange={() => handleInputChange('checks_completed_check', '1')}
                                                            style={{ width: "100px" }}
                                                        />

                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="checks_completed_check"
                                                            checked={formData.checks_completed_check == '0'}
                                                            onChange={() => handleInputChange('checks_completed_check', '0')}
                                                            style={{ width: "100px" }}
                                                        />
                                                    </span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="checks_completed"
                                                        value={formData?.checks_completed}
                                                        onChange={(e) => handleInputChange('checks_completed', e.target.value)}
                                                        style={{ maxWidth: '230px' }}
                                                    />

                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Warehouse Acceptance</h4>
                                        </div>
                                        <div>
                                            <TableGrid
                                                columns={columns}
                                                rows={formData?.connected_records}
                                                // checkboxSelection={true}
                                                totalRecords={formData?.connected_records?.length || 0}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Financial Data</h4>
                                            <Select
                                                options={currencies}
                                                onChange={(e) => handleInputChange('all_currency', e.value)}
                                                // placeholder="--"
                                                className="autoslct"
                                                name="all_currency"
                                                value={currencies.find(option => option.value === formData?.all_currency) || ''}
                                            />
                                        </div>
                                        <ul className='financial'>
                                            <li>
                                                <span>Air Freight :</span> <span >
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='air_freight_buying'
                                                        value={formData?.air_freight_buying || ''}
                                                        onChange={(e) => handleInputChange('air_freight_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='air_freight_selling'
                                                        value={formData?.air_freight_selling || ''}
                                                        onChange={(e) => handleInputChange('air_freight_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('air_freight_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="air_freight_currency"
                                                        value={currencies.find(option => option.value === formData?.air_freight_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Fuel Surcharge :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='fuel_surcharge_buying'
                                                        value={formData?.fuel_surcharge_buying || ''}
                                                        onChange={(e) => handleInputChange('fuel_surcharge_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='fuel_surcharge_selling'
                                                        value={formData?.fuel_surcharge_selling || ''}
                                                        onChange={(e) => handleInputChange('fuel_surcharge_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('fuel_surcharge_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="fuel_surcharge_currency"
                                                        value={currencies.find(option => option.value === formData?.fuel_surcharge_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Security Surcharge :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='security_surcharge_buying'
                                                        value={formData?.security_surcharge_buying || ''}
                                                        onChange={(e) => handleInputChange('security_surcharge_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='security_surcharge_selling'
                                                        value={formData?.security_surcharge_selling || ''}
                                                        onChange={(e) => handleInputChange('security_surcharge_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('security_surcharge_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="security_surcharge_currency"
                                                        value={currencies.find(option => option.value === formData?.security_surcharge_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Terminal Handling Fee :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='terminal_handling_fee_buying'
                                                        value={formData?.terminal_handling_fee_buying}
                                                        onChange={(e) => handleInputChange('terminal_handling_fee_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='terminal_handling_fee_selling'
                                                        value={formData?.terminal_handling_fee_selling}
                                                        onChange={(e) => handleInputChange('terminal_handling_fee_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('terminal_handling_fee_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="terminal_handling_fee_currency"
                                                        value={currencies.find(option => option.value === formData?.terminal_handling_fee_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Trucking :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='trucking_buying'
                                                        value={formData?.trucking_buying}
                                                        onChange={(e) => handleInputChange('trucking_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='trucking_selling'
                                                        value={formData?.trucking_selling}
                                                        onChange={(e) => handleInputChange('trucking_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('trucking_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="trucking_currency"
                                                        value={currencies.find(option => option.value === formData?.trucking_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Customs Clearance :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='customs_clearance_buying'
                                                        value={formData?.customs_clearance_buying}
                                                        onChange={(e) => handleInputChange('customs_clearance_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='customs_clearance_selling'
                                                        value={formData?.customs_clearance_selling}
                                                        onChange={(e) => handleInputChange('customs_clearance_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('customs_clearance_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="customs_clearance_currency"
                                                        value={currencies.find(option => option.value === formData?.customs_clearance_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Security Scanning :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='security_scanning_buying'
                                                        value={formData?.security_scanning_buying}
                                                        onChange={(e) => handleInputChange('security_scanning_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='security_scanning_selling'
                                                        value={formData?.security_scanning_selling}
                                                        onChange={(e) => handleInputChange('security_scanning_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('security_scanning_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="security_scanning_currency"
                                                        value={currencies.find(option => option.value === formData?.security_scanning_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Handling Fee :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='handling_fee_buying'
                                                        value={formData?.handling_fee_buying}
                                                        onChange={(e) => handleInputChange('handling_fee_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='handling_fee_selling'
                                                        value={formData?.handling_fee_selling}
                                                        onChange={(e) => handleInputChange('handling_fee_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('handling_fee_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="handling_fee_currency"
                                                        value={currencies.find(option => option.value === formData?.handling_fee_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Packing Fee :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='packing_fee_buying'
                                                        value={formData?.packing_fee_buying}
                                                        onChange={(e) => handleInputChange('packing_fee_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='packing_fee_selling'
                                                        value={formData?.packing_fee_selling}
                                                        onChange={(e) => handleInputChange('packing_fee_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="packing_fee_currency"
                                                        onChange={(e) => handleInputChange('packing_fee_currency', e.value)}
                                                        value={currencies.find(option => option.value === formData?.packing_fee_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Profit :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='profit_buying'
                                                        value={formData?.profit_buying}
                                                        onChange={(e) => handleInputChange('profit_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='profit_selling'
                                                        value={formData?.profit_selling}
                                                        onChange={(e) => handleInputChange('profit_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('profit_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="profit_currency"
                                                        value={currencies.find(option => option.value === formData?.profit_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Dangerous Goods :</span> <span>
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Buying'
                                                        name='dangerous_goods_fee_buying'
                                                        value={formData?.dangerous_goods_fee_buying}
                                                        onChange={(e) => handleInputChange('dangerous_goods_fee_buying', e.target.value)}
                                                    />
                                                    <Form.Control
                                                        type="number"
                                                        className=''
                                                        placeholder='Selling'
                                                        name='dangerous_goods_fee_selling'
                                                        value={formData?.dangerous_goods_fee_selling}
                                                        onChange={(e) => handleInputChange('dangerous_goods_fee_selling', e.target.value)}
                                                    />
                                                    <Select
                                                        options={currencies}
                                                        onChange={(e) => handleInputChange('dangerous_goods_fee_currency', e.value)}
                                                        // placeholder="--"
                                                        className="autoslct"
                                                        name="dangerous_goods_fee_currency"
                                                        value={currencies.find(option => option.value === formData?.dangerous_goods_fee_currency) || ''}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        }
                        {(selectedButton === 'general' && selectedTab === 'vwa') &&
                            <>
                                {<div className='flbg quotation_dv'>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <h3>Add Quotation</h3>
                                    </div>
                                    <hr />
                                    <Row className='mb-3'>
                                        <Col sm="12">
                                            <div className='modal_from'>
                                                <h4>Shipment Information</h4>
                                                <p></p>
                                                <Form.Group as={Row} className="mb-2 align-items-center" controlId="exampleForm.ControlInput1">
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>
                                                            {quotation?.customer_type == 'A' ? 'Agent Name' : 'Customer Name'}
                                                            <span></span>
                                                        </Form.Label>
                                                        <span className='d-flex'>
                                                            <Form.Control type="text" name="customer" className='flex-shrink-1' value={quotation?.name || ''} disabled />
                                                            <Button className='flex-grow-1 ms-2 me-2 customer_icon' onClick={contactModalOpen} disabled={isVwaReadOnly}><FontAwesomeIcon icon={faUser} /></Button>
                                                        </span>
                                                    </Col>
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>Origin <span className='danger'>*</span></Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(selected) => { handleVwaInputChange('origin', selected?.value || ''); }}
                                                            placeholder="Origin"
                                                            className=''
                                                            value={getDestination?.find(option => option.value === quotation?.origin)}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                            isDisabled={quotation?.shipment_type == 'E' || isVwaReadOnly}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="mb-2 align-items-center" controlId="exampleForm.ControlInput1">
                                                    <Col sm='6'>
                                                        <Form.Check
                                                            type="radio" label="Agent" id="customer_type-1" name="customer_type" value="A" checked={quotation?.customer_type == "A"}
                                                            onChange={() => handleVwaInputChange('customer_type', 'A')} disabled={isVwaReadOnly}
                                                        />
                                                        <Form.Check
                                                            type="radio" label="Customer" id="customer_type-2" name="customer_type" value="C" checked={quotation?.customer_type == "C"}
                                                            onChange={() => handleVwaInputChange('customer_type', 'C')} disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>Destination <span className='danger'>*</span></Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(selected) => { handleVwaInputChange('destination', selected?.value || ''); }}
                                                            placeholder="Destination"
                                                            className=''
                                                            value={getDestination?.find(option => option.value === quotation?.destination)}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                            isDisabled={quotation?.shipment_type == 'I' || isVwaReadOnly}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="mb-2 align-items-start" controlId="exampleForm.ControlInput1">
                                                    <Col sm='6'>
                                                        <Form.Check
                                                            type="radio" label="Export" id="shipment_type-1" name="shipment_type" value="E" disabled={isVwaReadOnly}
                                                            checked={quotation?.shipment_type === "E"} onChange={() => handleVwaInputChange('shipment_type', 'E')}
                                                        />
                                                        <Form.Check
                                                            type="radio" label="Import" id="shipment_type-2" name="shipment_type" value="I" disabled={isVwaReadOnly}
                                                            checked={quotation?.shipment_type === "I"} onChange={() => handleVwaInputChange('shipment_type', 'I')}
                                                        />
                                                    </Col>
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>Incoterm<span></span></Form.Label>
                                                        <Select
                                                            options={incotermOption}
                                                            onChange={(selected) => { handleVwaInputChange('incoterm', selected.value); }}
                                                            placeholder="Incoterm" className=''
                                                            value={incotermOption?.find(option => option.value === quotation?.incoterm)}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                            isDisabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                {/* Company, Agent, Phone, Email fields */}
                                                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>COMPANY :</Form.Label>
                                                        <Form.Control type="text" value={quotation?.company || ''} disabled readOnly />
                                                    </Col>
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>AGENT :</Form.Label>
                                                        <Form.Control type="text" value={quotation?.agent || ''} disabled readOnly />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>PHONE :</Form.Label>
                                                        <Form.Control type="text" value={quotation?.phone || ''} disabled readOnly />
                                                    </Col>
                                                    <Col sm='6'>
                                                        <Form.Label className='mb-2'>EMAIL :</Form.Label>
                                                        <Form.Control type="text" value={quotation?.email || ''} disabled readOnly />
                                                    </Col>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <div className='pickup_deliver_addrss_dv'>
                                        <Form.Group as={Row} className='mb-3'>
                                            <Col sm='6'>
                                                <Row className='g-2'>
                                                    <Col xs='12'><h3>Pickup Address</h3></Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <Form.Label className='mb-0 w-100'>Company Name :</Form.Label>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Form.Control
                                                            type="text"
                                                            className='form-control'
                                                            value={Array.isArray(quotation?.pickup_address) ? (quotation.pickup_address[0]?.company_name || '') : ''}
                                                            onChange={(e) => handleAddressChange('pickup_address', 'company_name', e.target.value)}
                                                            disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <Form.Label className='mb-0 w-100'>Address :</Form.Label>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Form.Control
                                                            type="text"
                                                            className='form-control'
                                                            value={Array.isArray(quotation?.pickup_address) ? (quotation.pickup_address[0]?.street_name || '') : ''}
                                                            onChange={(e) => handleAddressChange('pickup_address', 'street_name', e.target.value)}
                                                            disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <div className='d-flex align-items-center w-100'>
                                                            <Form.Label className='mb-0'>Postal Code :</Form.Label>
                                                            <span className='px-2'>/</span>
                                                            <Form.Label className='mb-0'>City :</Form.Label>
                                                        </div>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Row className='g-2'>
                                                            <Col xs='6'>
                                                                <Form.Control
                                                                    type="text"
                                                                    className='form-control'
                                                                    value={Array.isArray(quotation?.pickup_address) ? (quotation.pickup_address[0]?.postal_code || '') : ''}
                                                                    onChange={(e) => handleAddressChange('pickup_address', 'postal_code', e.target.value)}
                                                                    disabled={isVwaReadOnly}
                                                                />
                                                            </Col>
                                                            <Col xs='6'>
                                                                <Form.Control
                                                                    type="text"
                                                                    className='form-control'
                                                                    value={Array.isArray(quotation?.pickup_address) ? (quotation.pickup_address[0]?.city || '') : ''}
                                                                    onChange={(e) => handleAddressChange('pickup_address', 'city', e.target.value)}
                                                                    disabled={isVwaReadOnly}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <Form.Label className='mb-0 w-100'>Country :</Form.Label>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Form.Control
                                                            type="text"
                                                            className='form-control'
                                                            value={Array.isArray(quotation?.pickup_address) ? (quotation.pickup_address[0]?.country || '') : ''}
                                                            onChange={(e) => handleAddressChange('pickup_address', 'country', e.target.value)}
                                                            disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col sm='6'>
                                                <Row className='g-2'>
                                                    <Col xs='12'><h3>Deliver Address</h3></Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <Form.Label className='mb-0 w-100'>Company Name :</Form.Label>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Form.Control
                                                            type="text"
                                                            className='form-control'
                                                            value={Array.isArray(quotation?.deliver_address) ? (quotation.deliver_address[0]?.company_name || '') : ''}
                                                            onChange={(e) => handleAddressChange('deliver_address', 'company_name', e.target.value)}
                                                            disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <Form.Label className='mb-0 w-100'>Address :</Form.Label>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Form.Control
                                                            type="text"
                                                            className='form-control'
                                                            value={Array.isArray(quotation?.deliver_address) ? (quotation.deliver_address[0]?.street_name || '') : ''}
                                                            onChange={(e) => handleAddressChange('deliver_address', 'street_name', e.target.value)}
                                                            disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <div className='d-flex align-items-center w-100'>
                                                            <Form.Label className='mb-0'>Postal Code :</Form.Label>
                                                            <span className='px-2'>/</span>
                                                            <Form.Label className='mb-0'>City :</Form.Label>
                                                        </div>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Row className='g-2'>
                                                            <Col xs='6'>
                                                                <Form.Control
                                                                    type="text"
                                                                    className='form-control'
                                                                    value={Array.isArray(quotation?.deliver_address) ? (quotation.deliver_address[0]?.postal_code || '') : ''}
                                                                    onChange={(e) => handleAddressChange('deliver_address', 'postal_code', e.target.value)}
                                                                    disabled={isVwaReadOnly}
                                                                />
                                                            </Col>
                                                            <Col xs='6'>
                                                                <Form.Control
                                                                    type="text"
                                                                    className='form-control'
                                                                    value={Array.isArray(quotation?.deliver_address) ? (quotation.deliver_address[0]?.city || '') : ''}
                                                                    onChange={(e) => handleAddressChange('deliver_address', 'city', e.target.value)}
                                                                    disabled={isVwaReadOnly}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs='4' className='d-flex align-items-center'>
                                                        <Form.Label className='mb-0 w-100'>Country :</Form.Label>
                                                    </Col>
                                                    <Col xs='8'>
                                                        <Form.Control
                                                            type="text"
                                                            className='form-control'
                                                            value={Array.isArray(quotation?.deliver_address) ? (quotation.deliver_address[0]?.country || '') : ''}
                                                            onChange={(e) => handleAddressChange('deliver_address', 'country', e.target.value)}
                                                            disabled={isVwaReadOnly}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Form.Group>
                                    </div>


                                    <div className='shipment_details_wrap'>
                                        <h3> Shipment details</h3>
                                        <Row className='mb-3'>
                                            <Col sm='6'>
                                                <div className='modal_from'>
                                                    <h4>Packing Information</h4>
                                                    <p></p>
                                                    {!packageShow &&
                                                        <div className='expt_add_hwb mt-5'>
                                                            <Button onClick={() => setPackageShow(true)}>Add Packages</Button>
                                                        </div>
                                                    }
                                                    {packageShow &&
                                                        <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                                            <Col sm='12'>
                                                                <Accordion defaultActiveKey="0" flush>
                                                                    {packageGroups.map((group, idx) => (
                                                                        <Accordion.Item eventKey={idx.toString()} key={idx}>
                                                                            <Accordion.Body>
                                                                                <Form.Group as={Row} className="mb-2">
                                                                                    <Col sm='6'>
                                                                                        <Form.Label>Number of packages<span className='danger'>*</span></Form.Label>
                                                                                        <Form.Control type="text" name='number_of_packages' value={group.number_of_packages || ''}
                                                                                            onChange={e => handleGroupChange(idx, 'number_of_packages', e.target.value)}
                                                                                            disabled={isVwaReadOnly}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col sm='6'>
                                                                                        <Form.Label>Gross Weight (kg)<span></span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={group.gross_weight || ''}
                                                                                            onChange={e => handleGroupChange(idx, 'gross_weight', e.target.value)}
                                                                                            disabled={isVwaReadOnly}
                                                                                        />
                                                                                    </Col>
                                                                                </Form.Group>
                                                                                <Form.Group as={Row} className="mb-2">
                                                                                    <Col sm='4'>
                                                                                        <Form.Label>Length (cm)<span className='danger'>*</span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={group.length || ''}
                                                                                            onChange={e => handleGroupChange(idx, 'length', e.target.value)}
                                                                                            disabled={isVwaReadOnly}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col sm='4'>
                                                                                        <Form.Label>Width (cm)<span></span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={group.width || ''}
                                                                                            onChange={e => handleGroupChange(idx, 'width', e.target.value)}
                                                                                            disabled={isVwaReadOnly}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col sm='4'>
                                                                                        <Form.Label>Height (cm)<span className='danger'>*</span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={group.height || ''}
                                                                                            onChange={e => handleGroupChange(idx, 'height', e.target.value)}
                                                                                            disabled={isVwaReadOnly}
                                                                                        />
                                                                                    </Col>
                                                                                </Form.Group>
                                                                                <Form.Group as={Row} className="mb-2">
                                                                                    <Col sm='6'>
                                                                                        <Form.Label>Volumetric Weight (kg)</Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={group.volumetric_weight || ''}
                                                                                            disabled
                                                                                        />
                                                                                    </Col>
                                                                                    <Col sm='6'>
                                                                                        <Form.Label>Chargeable Weight (kg)<span></span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={group.chargeable_weight || ''}
                                                                                            disabled
                                                                                        />
                                                                                    </Col>
                                                                                </Form.Group>
                                                                                {packageGroups.length > 1 && (
                                                                                    <Button
                                                                                        variant="outline-primary"
                                                                                        className="w-100"
                                                                                        onClick={() => handleDeleteGroup(idx)}
                                                                                    >
                                                                                        Delete Group
                                                                                    </Button>
                                                                                )}
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                    ))}
                                                                </Accordion>
                                                                <Button
                                                                    variant="primary"
                                                                    className="w-100 mt-2"
                                                                    onClick={handleSaveHawb}
                                                                >
                                                                    {editIndex !== null ? 'Update' : 'Save'}
                                                                </Button>
                                                            </Col>
                                                        </Form.Group>
                                                    }
                                                </div>
                                            </Col>

                                            <Col sm='6'>
                                                <div className='modal_from'>
                                                    <h4>Packing Details</h4>
                                                    <p></p>
                                                    <div className='d-flex justify-content-between chargable'>
                                                        <span>Total Vol Weight : {totals.totalVolumetricWeight}</span>
                                                        <span>Total Charge Weight : {totals.totalChargeableWeight}</span>
                                                    </div>
                                                    <div className='expcet_hawb'>
                                                        {savedPackages.map((item, idx) => (
                                                            <div key={idx} className='hawb_box'>
                                                                <div className='d-flex justify-content-between align-items-center'>
                                                                    <div><h3>Number of packages: {item.number_of_packages}</h3></div>
                                                                    <div>
                                                                        <Button variant="link" onClick={() => handleEditHawb(idx)}><img src={edit} /></Button>
                                                                        <Button variant="link" onClick={() => handleDeleteHawb(idx)}><img src={Trash} /></Button>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div>
                                                                        <span>Gross Weight: {item.gross_weight}</span> <span> Width (cm): {item.width}</span> <span> Height (cm): {item.height}</span>
                                                                    </div>
                                                                    <div>
                                                                        <span>Volumetric Weight (kg): {item.volumetric_weight} </span><span> Chargeable Weight (kg): {item.chargeable_weight}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {(quotation?.origin === 'AMS' || quotation?.destination === 'AMS') && (
                                        <div className='AirfreightRates shipment_details_wrap'>
                                            <h3>Charges in AMS</h3>
                                            <Table size="sm" className="align-middle text-center">
                                                <thead>
                                                    <tr>
                                                        <th>Services</th>
                                                        <th style={{ width: "8%" }}>Airport</th>
                                                        <th>Rate</th>
                                                        <th style={{ width: "10%" }}>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                value={quotation?.shipment_type === "E" ? "1. Terminal Handling Charges (Export)" : quotation?.shipment_type === "I" ? "1. Terminal Handling Charges (Import)" : ""}
                                                                className='form-control'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                defaultValue="AMS"
                                                                className='form-control'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? (`Min: ${quotationFormData.export_terminal_min || ''} / Max: ${quotationFormData.export_terminal_max || ''} / Rate 1–1000 kg (EUR/kg): ${quotationFormData.export_terminal_rate_1} / Rate 1001–2000 kg (EUR/kg): ${quotationFormData.export_terminal_rate_2} / Rate 2001+ kg (EUR/kg) : ${quotationFormData.export_terminal_rate_3}`) : quotation?.shipment_type === "I" ? (`Min: ${quotationFormData.import_terminal_min || ''} / Rate 1–1000 kg (EUR/kg): ${quotationFormData.import_terminal_rate_1} / Rate 1001–2000 kg (EUR/kg): ${quotationFormData.import_terminal_rate_2} / Rate 2001+ kg (EUR/kg) : ${quotationFormData.import_terminal_rate_3}`) : ""}

                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={`€ ${getLocalCharges.terminal || "0.00"}`}

                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? "2. KLN Warehouse Handling (Export)" : quotation?.shipment_type === "I" ? "2. KLN Warehouse Handling (Import)" : ""}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                defaultValue="AMS"
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? `Fixed Fee per AWB (EUR) : ${quotationFormData.export_warehouse_fixed || ''}` : quotation?.shipment_type === "I" ? `Rate (EUR/Kg) : ${quotationFormData?.import_warehouse_rate || ''} / Minimum (EUR) : ${quotationFormData.import_warehouse_min || ''} / Maximum (EUR) : ${quotationFormData.import_warehouse_max || ''}` : ""}

                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={`€ ${getLocalCharges.warehouse || "0.00"}`}

                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? "3. AWB / Admin Fee (Export)" : quotation?.shipment_type === "I" ? "3. AWB / Admin Fee (Import)" : ""}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                defaultValue="AMS"
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? `Fixed Fee per AWB (EUR) : ${quotationFormData.export_awb_fee || ''}` : quotation?.shipment_type === "I" ? `Fixed Fee per AWB (EUR) : ${quotationFormData.import_awb_fee || ''}` : ''}

                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={`€ ${getLocalCharges.awb || "0.00"}`}

                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? "4. Customs Clearance (Export)" : quotation?.shipment_type === "I" ? "4. Customs Clearance (Import)" : ""}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                defaultValue="AMS"
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? `Fixed Fee incl. 2 HS Codes (EUR) : ${quotationFormData.export_customs_fixed} / Extra HS Code Rate (EUR each) : ${quotationFormData.export_customs_extra_hs}` : quotation?.shipment_type === "I" ? `Fixed Fee incl. 2 HS Codes (EUR) : ${quotationFormData.import_customs_fixed} / Extra HS Code Rate (EUR each) : ${quotationFormData.import_customs_extra_hs}` : ''}

                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={`€ ${getLocalCharges.customs || "0.00"}`}

                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? "5. Pick-Up in the Netherlands (Export)" : quotation?.shipment_type === "I" ? "5. Pick-Up in the Netherlands (Import)" : ""}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                defaultValue="AMS"
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? `Min : ${quotationFormData.export_pickup_min || ''} / Max : ${quotationFormData.export_pickup_max || ''} / Rate 1–1000 kg (EUR/kg) : ${quotationFormData.export_pickup_rate_1 || ''} / Rate 1001–2000 kg (EUR/kg) : ${quotationFormData.export_pickup_rate_2 || ''} / Rate 2001+ kg (EUR/kg) : ${quotationFormData.export_pickup_rate_3 || ''} / Fuel Surcharge (%) : ${quotationFormData.export_pickup_fuel || ''}` : quotation?.shipment_type === "I" ? `Min : ${quotationFormData.import_delivery_min || ''} / Max : ${quotationFormData.import_delivery_max || ''} / Rate 1–1000 kg (EUR/kg) : ${quotationFormData.import_delivery_rate_1 || ''} / Rate 1001–2000 kg (EUR/kg) : ${quotationFormData.import_delivery_rate_2 || ''} / Rate 2001+ kg (EUR/kg) : ${quotationFormData.import_delivery_rate_3 || ''} / Fuel Surcharge (%) : ${quotationFormData.import_delivery_fuel || ''}` : ""}

                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={`€ ${getLocalCharges.pickup_delivery || "0.00"}`}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={quotation?.shipment_type === "E" ? "5. Pick up Fuel Surcharge (%) (Export)" : quotation?.shipment_type === "I" ? "5. Pick up Fuel Surcharge (%) (Import)" : ""}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                defaultValue="AMS"
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={` Rate : ${getLocalCharges.fuel_percent || ''} %`}

                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                disabled
                                                                type="text"
                                                                className='form-control'
                                                                value={`€ ${getLocalCharges.fuel || "0.00"} `}
                                                            />
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </Table>
                                            <div className='dimension_add d-flex justify-content-end align-items-center mb-3'>
                                                <p className='mb-2 m-0 subtotal_dv'><span className='me-2'>Total - </span><span className='fw-bold'>{getLocalCharges.total || "0.00"}</span></p>
                                            </div>
                                            <div className='text-end '>
                                            </div>
                                        </div>
                                    )}

                                    <div className='AirfreightRates shipment_details_wrap'>
                                        <h3>Airfreight</h3>
                                        <Table size="sm" className="align-middle text-center Airfreight_rates_table">
                                            <thead>
                                                <tr>
                                                    <th>Airline  <span className='danger'>*</span></th>
                                                    <th>Product  <span className='danger'>*</span></th>
                                                    <th>To  <span className='danger'>*</span></th>
                                                    <th>Via  <span className='danger'>*</span></th>
                                                    {/* <th>Freight  <span className='danger'>*</span></th> */}

                                                    <th>Base</th>
                                                    <th>Rate</th>
                                                    <th>Fuel</th>
                                                    <th>Risk</th>
                                                    <th>Fees</th>
                                                    <th>Freight  <span className='danger'>*</span></th>
                                                    <th>Surcharges</th>

                                                    <th>Validity <span className='danger'>*</span></th>
                                                    <th>Total</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {afRows.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>

                                                            <Select
                                                                options={getOwnerCodes}
                                                                onChange={(selected) => { handleAFRowChange(idx, 'airline', selected ? selected.value : ''); }}
                                                                placeholder="To"
                                                                className=''
                                                                name="airline"
                                                                value={getOwnerCodes?.find(option => option.value === row.airline) || null}
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                }}
                                                                isDisabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.product}
                                                                onChange={e => handleAFRowChange(idx, 'product', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(selected) => { handleAFRowChange(idx, 'to', selected ? selected.value : ''); }}
                                                                placeholder="To"
                                                                className='down_selct'
                                                                name="to"
                                                                value={getDestination?.find(option => option.value === row.to) || null}
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                }}
                                                                isDisabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(selected) => { handleAFRowChange(idx, 'via', selected ? selected.value : ''); }}
                                                                placeholder="Via"
                                                                className='down_selct'
                                                                name="via"
                                                                value={getDestination?.find(option => option.value === row.via) || null}
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                }}
                                                                isDisabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.base || ''}
                                                                onChange={e => handleAFRowChange(idx, 'base', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.rate || ''}
                                                                onChange={e => handleAFRowChange(idx, 'rate', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.fuel || ''}
                                                                onChange={e => handleAFRowChange(idx, 'fuel', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.risk || ''}
                                                                onChange={e => handleAFRowChange(idx, 'risk', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.fees || ''}
                                                                onChange={e => handleAFRowChange(idx, 'fees', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.freightAmount || ''}
                                                                onChange={e => handleAFRowChange(idx, 'freightAmount', e.target.value)}
                                                                disabled
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.surcharges || ''}
                                                                onChange={e => handleAFRowChange(idx, 'surcharges', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="date"
                                                                className="form-control"
                                                                value={row.validity || ''}
                                                                onChange={e => handleAFRowChange(idx, 'validity', e.target.value)}
                                                                disabled={isVwaReadOnly}
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.total || ''}
                                                                onChange={e => handleAFRowChange(idx, 'total', e.target.value)}
                                                                disabled
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td>
                                                            {afRows.length > 1 && !isVwaReadOnly && (
                                                                <img src={dlt} alt='dlt' style={{ cursor: 'pointer' }} className="dlt_icon" onClick={() => handleDeleteAFRow(idx)} />
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        <div className='dimension_add d-flex justify-content-between align-items-center'>
                                            <button type="button" className="btn btn-primary" onClick={handleAddAFRow} disabled={isVwaReadOnly}>+ Add Row</button>
                                            <p className='mb-2 m-0 subtotal_dv'><span className='me-2'>Total - </span><span className='fw-bold'>{getAFGrandTotal().toFixed(2)}</span></p>
                                        </div>
                                        <div className=' text-end '>
                                        </div>
                                    </div>


                                </div>
                                }
                            </>
                        }
                        {selectedButton === 'attachment' &&
                            <div className='flbg'>
                                <div className='all_file mb-3'>
                                    <h4>All files</h4>
                                    <Button variant="primary" onClick={imageModalUpload}> <img src={Uploadw} /> Upload file</Button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(e) => handleFileChange(e, 'A')}
                                        multiple
                                    />
                                </div>
                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="attach_tab">
                                    <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.map((data, index) => {
                                                    const fileName = data.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();

                                                    return (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td><div className='file_attch'>
                                                                {["jpeg", "jpg", "png", "webp"].includes(data.file_path?.split(".")[data.file_path?.split(".").length - 1]
                                                                ) ? (
                                                                    <>
                                                                        <div className='file_icon'>
                                                                            <img
                                                                                src={data.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "22px",
                                                                                    maxHeight: "22px",
                                                                                    marginRight: "10px",
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className='file_icon'>
                                                                            <FontAwesomeIcon icon={faFileLines} />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{data.file_name}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic" disabled={data.remarks_attachment === 1}>
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["doc", "docx", "txt"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>

                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["xls", "xlsx", "csv"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>

                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["pdf"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"

                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Images" title={<span>Images </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["jpg", "jpeg", "png", "bmp"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => {
                                                        const fileName = data.file_name;
                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                        const extension = fileName?.split(".").pop();

                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <Form.Check // prettier-ignore
                                                                        type="checkbox"
                                                                        id="checkbox"

                                                                    />
                                                                </td>
                                                                <td className="delimg">
                                                                    <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                </td>
                                                                <td>
                                                                    <div className='file_attch'>
                                                                        <div className='file_icon'>
                                                                            <img
                                                                                src={data.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "22px",
                                                                                    maxHeight: "22px",
                                                                                    marginRight: "10px",
                                                                                }}

                                                                            />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{data.file_name}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td><p>{data.category[0]}</p></td>
                                                                <td>
                                                                    <p>{data.modified_name}</p>
                                                                    <span>{data.modified_email}</span>
                                                                </td>
                                                                <td>
                                                                    <span>{data.last_modified}</span>
                                                                </td>
                                                                <td>
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>

                                                                            <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                            <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                </Tabs>
                            </div>
                        }
                        {selectedButton === 'remarks' &&
                            <div className='chat_bg'>
                                <div className='flbg right_side record_remarks'>
                                    <div className='chat_box'>
                                        {formData?.remarks?.map((msg, index) => (
                                            <>
                                                <Accordion key={index} activeKey={expandedKeys}>
                                                    <Accordion.Item eventKey={index.toString()}>
                                                        <Accordion.Header onClick={() => toggleAccordionItem(index, msg, 'all')} className=''>
                                                            <div className='position-relative'><img src={Pack} /> {msg.created_by}</div>
                                                            <div className='acorright'> {msg.attachments?.length > 0 && <FontAwesomeIcon icon={faPaperclip} />} <span>{msg.date} | {msg.time}</span></div></Accordion.Header>
                                                        <Accordion.Body>
                                                            {msg.message}
                                                            {msg.attachments?.length > 0 &&
                                                                <div className='d-flex mt-1 '>
                                                                    {msg.attachments?.map((file, index) => {
                                                                        const fileName = file?.file_name;
                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                        const extension = fileName?.split(".").pop();
                                                                        return (
                                                                            <>
                                                                                <div key={`ns_${index}`} className="mag_image">
                                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                    ) ? (
                                                                                        <>
                                                                                            <img
                                                                                                src={file.file_path}
                                                                                                alt="Preview"
                                                                                                className=''
                                                                                                style={{
                                                                                                    maxWidth: "30px",
                                                                                                    maxHeight: "30px",
                                                                                                    marginRight: "5px",
                                                                                                }}

                                                                                            />
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <span className="d-flex rafilename">
                                                                                                <img src={Docmnt} className="fileimg" />
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                    <span className="rafilename">
                                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                    </span>
                                                                                    <button
                                                                                        className="msg_download"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            handleDownload(file.file_path, file.file_name)
                                                                                        }
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faFileArrowDown} />
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </div>
                                                            }
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </>
                                        ))}
                                    </div>
                                    <div>
                                        <Form.Group className='massge_text'>
                                            <div className='mag_send'>
                                                <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileChange(e, 'R')}
                                                    multiple
                                                />
                                            </div>
                                            <div className='d-flex reco_image'>
                                                {rfiles.map((file, index) => {
                                                    const fileName = file?.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        <div key={index} className='img-thumbnail'>
                                                            {file?.type?.startsWith('image/') ? (
                                                                <img
                                                                    // src={URL.createObjectURL(file)}
                                                                    src={file.base64}
                                                                    alt="Preview"
                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                />
                                                            ) : (
                                                                <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                            )}
                                                            <span className="rafilename">
                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                            </span>
                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index, 'R')}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder='Enter a description...'
                                                    rows={2}
                                                    name='message'
                                                    onChange={conversationChange}
                                                    value={sendData?.message || ''}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        }
                    </Col>
                </Row >
            </div >
            <Modal show={typeModal} onHide={() => { setTypeModal(false); }} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{modalSection === 'S' ? 'Attachment Type' : 'Remove Attachment'}</h3>
                    <p>{modalSection === 'S' ? 'Update this attachment type' : 'Are you sure you want delete this attachment?'}</p>
                    {modalSection === 'S' &&
                        <Form.Group className="me-2">
                            <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                                <option value="0">Select</option>
                                <option value="Invoice">Invoice</option>
                                <option value="Packinglist">Packinglist</option>
                                <option value="Emails">Emails</option>
                                <option value="HAWB">HAWB</option>
                                <option value="MAWB">MAWB</option>
                                <option value="Manifest">Manifest</option>
                                <option value="Customs">Customs</option>
                                <option value="Proposal">Proposal</option>
                                <option value="Other">Other</option>
                            </Form.Select>
                        </Form.Group>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        {modalSection === 'S' ?
                            <Button variant="primary" onClick={modalUpdate}>
                                Update
                            </Button>
                            :
                            <>
                                <Button variant="secondary" onClick={() => setTypeModal(false)}>
                                    No
                                </Button>
                                <Button variant="primary" onClick={modalUpdate}>
                                    Yes
                                </Button>
                            </>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={showModalUpload} onHide={closeModalUpload} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <div className='modal-title h4'>Upload Attachments</div>
                    <p className='text-start'>Drag and drop or browse to upload your attachments.</p>
                </Modal.Header>
                <Modal.Body>
                    <div className='type_work'>

                        <div className='ra_condition'>
                            <div
                                className='dropfile'
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <img src={Shipupload} alt="upload" />
                                <h3>Drag and drop files here</h3>
                                <p>Or</p>
                                <button className='btn btn-primary drpbtn' onClick={uploadTarget ? (e) => handleBrowseFiles(e, uploadTarget) : handleBrowseFiles}>Browse Files</button>
                                <span>Maximum file size 25 MB</span>
                                <input
                                    type="file"
                                    ref={(el) => {
                                        if (uploadTarget) {
                                            fileInputRefs.current[uploadTarget] = el;
                                        }
                                    }}
                                    style={{ display: 'none' }}
                                    onChange={uploadTarget ? (e) => handleFileChange(e, 'C', uploadTarget) : (e) => handleFileChange(e, 'A')}
                                    multiple
                                />
                            </div>
                            <div className='attach_shipment'>
                                {files.map((file, index) => (
                                    <div key={index} className='uploadfil'>
                                        {file.base64.includes('image') ? (
                                            <>
                                                <img
                                                    src={file.base64}
                                                    alt="Preview"
                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                                <span>{file.file_name}</span>
                                            </>
                                        ) : (
                                            <>  <img src={Docmnt} className='fileimg' /> <span> {file.file_name}</span> </>
                                        )}
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={imageUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={addLocationModal} onHide={hideLocationModal} className='addfrom add_category_modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm="12" className='mb-3'>
                            <Form.Label>Station<span className='text-danger'>*</span></Form.Label>
                            <Select
                                options={getDestination}
                                onChange={(e) => handleLocationChange('station', e.value)}
                                placeholder="Station"
                                className="w-100"
                                name="station"
                                value={getDestination.find(option => option.value === locationData?.station) || null}
                            />
                        </Col>
                        <Col sm="12" className='mb-3'>
                            <Form.Label>Location Name<span className='text-danger'>*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter Location" value={locationData.location || ''} onChange={(e) => handleLocationChange('location', e.target.value)} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={hideLocationModal}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleLocationSave}>Save</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={locationModal} onHide={() => setLocationModal(false)} className='addfrom add_category_modal' centered size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className='text-end mt-2 fwr_customer_add'><Button variant="primary" onClick={handleAddLocation} >+ Add Location</Button></span>
                    <div className='trashdonload add_category_modal_bdy_content mt-0'>
                        {!isLoadingl && <div ref={lgridRef} className='bookinggrid'></div>}
                    </div>
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setLocationModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleLocationApply}>Apply</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={contactModal} onHide={() => setContactModal(false)} className='addfrom add_category_modal' centered size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Contact Finder</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Customer
                        isModal={true}
                        onSelect={handleSelect}
                        showAddCustomer={false}
                    />
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setContactModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleCustomerApply}>Apply</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                className="raintrac"
                show={showDeleteConfirm}
                onHide={() => setShowDeleteConfirm(false)}
                centered
            >
                <Modal.Header closeButton />

                <Modal.Body>
                    <h2>Confirm Delete</h2>

                    <p>
                        {deleteIds.length} record
                        {deleteIds.length > 1 ? "s" : ""} will be deleted.
                        <br />
                        Are you sure you want to continue?
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowDeleteConfirm(false)}
                    >
                        No
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddExport